// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file backend/v1/backend.proto (package backend.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum backend.v1.CardTokenType
 */
export enum CardTokenType {
  /**
   * @generated from enum value: CARD_TOKEN_TYPE_PIN = 0;
   */
  PIN = 0,

  /**
   * @generated from enum value: CARD_TOKEN_TYPE_PIN_CHANGE = 1;
   */
  PIN_CHANGE = 1,

  /**
   * @generated from enum value: CARD_TOKEN_TYPE_CARD_DATA = 2;
   */
  CARD_DATA = 2,

  /**
   * @generated from enum value: CARD_TOKEN_TYPE_APPLE_PROVISIONING = 3;
   */
  APPLE_PROVISIONING = 3,

  /**
   * @generated from enum value: CARD_TOKEN_TYPE_GOOGLE_PROVISIONING = 4;
   */
  GOOGLE_PROVISIONING = 4,

  /**
   * @generated from enum value: CARD_TOKEN_TYPE_DIGITALIZATION_PAI = 5;
   */
  DIGITALIZATION_PAI = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(CardTokenType)
proto3.util.setEnumType(CardTokenType, "backend.v1.CardTokenType", [
  { no: 0, name: "CARD_TOKEN_TYPE_PIN" },
  { no: 1, name: "CARD_TOKEN_TYPE_PIN_CHANGE" },
  { no: 2, name: "CARD_TOKEN_TYPE_CARD_DATA" },
  { no: 3, name: "CARD_TOKEN_TYPE_APPLE_PROVISIONING" },
  { no: 4, name: "CARD_TOKEN_TYPE_GOOGLE_PROVISIONING" },
  { no: 5, name: "CARD_TOKEN_TYPE_DIGITALIZATION_PAI" },
]);

/**
 * @generated from enum backend.v1.CustomerDeliveryAddressType
 */
export enum CustomerDeliveryAddressType {
  /**
   * @generated from enum value: CUSTOMER_DELIVERY_ADDRESS_OTHER = 0;
   */
  CUSTOMER_DELIVERY_ADDRESS_OTHER = 0,

  /**
   * @generated from enum value: CUSTOMER_DELIVERY_ADDRESS_PERMANENT_RESIDENCE = 1;
   */
  CUSTOMER_DELIVERY_ADDRESS_PERMANENT_RESIDENCE = 1,

  /**
   * @generated from enum value: CUSTOMER_DELIVERY_ADDRESS_TEMPORARY_RESIDENCE = 2;
   */
  CUSTOMER_DELIVERY_ADDRESS_TEMPORARY_RESIDENCE = 2,

  /**
   * @generated from enum value: CUSTOMER_DELIVERY_ADDRESS_WORK = 3;
   */
  CUSTOMER_DELIVERY_ADDRESS_WORK = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CustomerDeliveryAddressType)
proto3.util.setEnumType(CustomerDeliveryAddressType, "backend.v1.CustomerDeliveryAddressType", [
  { no: 0, name: "CUSTOMER_DELIVERY_ADDRESS_OTHER" },
  { no: 1, name: "CUSTOMER_DELIVERY_ADDRESS_PERMANENT_RESIDENCE" },
  { no: 2, name: "CUSTOMER_DELIVERY_ADDRESS_TEMPORARY_RESIDENCE" },
  { no: 3, name: "CUSTOMER_DELIVERY_ADDRESS_WORK" },
]);

/**
 * @generated from enum backend.v1.CardType
 */
export enum CardType {
  /**
   * @generated from enum value: CARD_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CARD_TYPE_PHYSICAL = 1;
   */
  PHYSICAL = 1,

  /**
   * @generated from enum value: CARD_TYPE_VIRTUAL = 2;
   */
  VIRTUAL = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CardType)
proto3.util.setEnumType(CardType, "backend.v1.CardType", [
  { no: 0, name: "CARD_TYPE_UNKNOWN" },
  { no: 1, name: "CARD_TYPE_PHYSICAL" },
  { no: 2, name: "CARD_TYPE_VIRTUAL" },
]);

/**
 * @generated from enum backend.v1.CardStatus
 */
export enum CardStatus {
  /**
   * @generated from enum value: CARD_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CARD_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: CARD_STATUS_BLOCKED = 2;
   */
  BLOCKED = 2,

  /**
   * @generated from enum value: CARD_STATUS_TEMPORARY_BLOCKED = 3;
   */
  TEMPORARY_BLOCKED = 3,

  /**
   * @generated from enum value: CARD_STATUS_REPLACED = 4;
   */
  REPLACED = 4,

  /**
   * @generated from enum value: CARD_STATUS_SOFT_DELETE = 5;
   */
  SOFT_DELETE = 5,

  /**
   * @generated from enum value: CARD_STATUS_ACCOUNT_BLOCKED = 6;
   */
  ACCOUNT_BLOCKED = 6,

  /**
   * @generated from enum value: CARD_STATUS_IN_CREATION = 7;
   */
  IN_CREATION = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(CardStatus)
proto3.util.setEnumType(CardStatus, "backend.v1.CardStatus", [
  { no: 0, name: "CARD_STATUS_UNKNOWN" },
  { no: 1, name: "CARD_STATUS_ACTIVE" },
  { no: 2, name: "CARD_STATUS_BLOCKED" },
  { no: 3, name: "CARD_STATUS_TEMPORARY_BLOCKED" },
  { no: 4, name: "CARD_STATUS_REPLACED" },
  { no: 5, name: "CARD_STATUS_SOFT_DELETE" },
  { no: 6, name: "CARD_STATUS_ACCOUNT_BLOCKED" },
  { no: 7, name: "CARD_STATUS_IN_CREATION" },
]);

/**
 * @generated from enum backend.v1.CardStatusReasonCode
 */
export enum CardStatusReasonCode {
  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_CLIENT_REQUESTED_LOCK = 2;
   */
  CLIENT_REQUESTED_LOCK = 2,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_LOST_CARD = 3;
   */
  LOST_CARD = 3,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_STOLEN_CARD = 4;
   */
  STOLEN_CARD = 4,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_ISSUER_REQUEST_GENERAL = 5;
   */
  ISSUER_REQUEST_GENERAL = 5,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_ISSUER_REQUEST_FRAUD = 6;
   */
  ISSUER_REQUEST_FRAUD = 6,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_ISSUER_REQUEST_LEGAL = 7;
   */
  ISSUER_REQUEST_LEGAL = 7,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_ISSUER_REQUEST_INCORRECT_OPENING = 8;
   */
  ISSUER_REQUEST_INCORRECT_OPENING = 8,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_CARD_DAMAGED_OR_NOT_WORKING = 9;
   */
  CARD_DAMAGED_OR_NOT_WORKING = 9,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_USER_REQUEST = 10;
   */
  USER_REQUEST = 10,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_ISSUER_REQUEST_CUSTOMER_DECEASED = 11;
   */
  ISSUER_REQUEST_CUSTOMER_DECEASED = 11,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_PRODUCT_DOES_NOT_RENEW = 12;
   */
  PRODUCT_DOES_NOT_RENEW = 12,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_PRODUCT_CHANGE = 13;
   */
  PRODUCT_CHANGE = 13,

  /**
   * @generated from enum value: CARD_STATUS_REASON_CODE_RENEWED = 14;
   */
  RENEWED = 14,
}
// Retrieve enum metadata with: proto3.getEnumType(CardStatusReasonCode)
proto3.util.setEnumType(CardStatusReasonCode, "backend.v1.CardStatusReasonCode", [
  { no: 0, name: "CARD_STATUS_REASON_CODE_UNKNOWN" },
  { no: 1, name: "CARD_STATUS_REASON_CODE_NONE" },
  { no: 2, name: "CARD_STATUS_REASON_CODE_CLIENT_REQUESTED_LOCK" },
  { no: 3, name: "CARD_STATUS_REASON_CODE_LOST_CARD" },
  { no: 4, name: "CARD_STATUS_REASON_CODE_STOLEN_CARD" },
  { no: 5, name: "CARD_STATUS_REASON_CODE_ISSUER_REQUEST_GENERAL" },
  { no: 6, name: "CARD_STATUS_REASON_CODE_ISSUER_REQUEST_FRAUD" },
  { no: 7, name: "CARD_STATUS_REASON_CODE_ISSUER_REQUEST_LEGAL" },
  { no: 8, name: "CARD_STATUS_REASON_CODE_ISSUER_REQUEST_INCORRECT_OPENING" },
  { no: 9, name: "CARD_STATUS_REASON_CODE_CARD_DAMAGED_OR_NOT_WORKING" },
  { no: 10, name: "CARD_STATUS_REASON_CODE_USER_REQUEST" },
  { no: 11, name: "CARD_STATUS_REASON_CODE_ISSUER_REQUEST_CUSTOMER_DECEASED" },
  { no: 12, name: "CARD_STATUS_REASON_CODE_PRODUCT_DOES_NOT_RENEW" },
  { no: 13, name: "CARD_STATUS_REASON_CODE_PRODUCT_CHANGE" },
  { no: 14, name: "CARD_STATUS_REASON_CODE_RENEWED" },
]);

/**
 * @generated from enum backend.v1.CardLockLevel
 */
export enum CardLockLevel {
  /**
   * @generated from enum value: CARD_LOCK_LEVEL_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CARD_LOCK_LEVEL_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: CARD_LOCK_LEVEL_CLIENT = 2;
   */
  CLIENT = 2,

  /**
   * @generated from enum value: CARD_LOCK_LEVEL_ADMIN = 3;
   */
  ADMIN = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CardLockLevel)
proto3.util.setEnumType(CardLockLevel, "backend.v1.CardLockLevel", [
  { no: 0, name: "CARD_LOCK_LEVEL_UNKNOWN" },
  { no: 1, name: "CARD_LOCK_LEVEL_NONE" },
  { no: 2, name: "CARD_LOCK_LEVEL_CLIENT" },
  { no: 3, name: "CARD_LOCK_LEVEL_ADMIN" },
]);

/**
 * @generated from message backend.v1.PaginationRequest
 */
export class PaginationRequest extends Message<PaginationRequest> {
  /**
   * @generated from field: int32 pageSize = 1;
   */
  pageSize = 0;

  /**
   * @generated from field: optional string pageToken = 2;
   */
  pageToken?: string;

  constructor(data?: PartialMessage<PaginationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PaginationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "pageToken", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaginationRequest {
    return new PaginationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaginationRequest {
    return new PaginationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaginationRequest {
    return new PaginationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PaginationRequest | PlainMessage<PaginationRequest> | undefined, b: PaginationRequest | PlainMessage<PaginationRequest> | undefined): boolean {
    return proto3.util.equals(PaginationRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Empty
 */
export class Empty extends Message<Empty> {
  constructor(data?: PartialMessage<Empty>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Empty";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Empty {
    return new Empty().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Empty {
    return new Empty().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Empty {
    return new Empty().fromJsonString(jsonString, options);
  }

  static equals(a: Empty | PlainMessage<Empty> | undefined, b: Empty | PlainMessage<Empty> | undefined): boolean {
    return proto3.util.equals(Empty, a, b);
  }
}

/**
 * @generated from message backend.v1.ThreeDSPaymentConfirmationRequest
 */
export class ThreeDSPaymentConfirmationRequest extends Message<ThreeDSPaymentConfirmationRequest> {
  /**
   * @generated from field: string transactionId = 1;
   */
  transactionId = "";

  /**
   * @generated from field: bool confirmed = 2;
   */
  confirmed = false;

  constructor(data?: PartialMessage<ThreeDSPaymentConfirmationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ThreeDSPaymentConfirmationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transactionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "confirmed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ThreeDSPaymentConfirmationRequest {
    return new ThreeDSPaymentConfirmationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ThreeDSPaymentConfirmationRequest {
    return new ThreeDSPaymentConfirmationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ThreeDSPaymentConfirmationRequest {
    return new ThreeDSPaymentConfirmationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ThreeDSPaymentConfirmationRequest | PlainMessage<ThreeDSPaymentConfirmationRequest> | undefined, b: ThreeDSPaymentConfirmationRequest | PlainMessage<ThreeDSPaymentConfirmationRequest> | undefined): boolean {
    return proto3.util.equals(ThreeDSPaymentConfirmationRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.PendingThreeDSConfirmation
 */
export class PendingThreeDSConfirmation extends Message<PendingThreeDSConfirmation> {
  /**
   * @generated from field: string transactionId = 1;
   */
  transactionId = "";

  /**
   * @generated from field: string merchantName = 2;
   */
  merchantName = "";

  /**
   * @generated from field: string purchaseAmount = 3;
   */
  purchaseAmount = "";

  /**
   * @generated from field: string purchaseCurrency = 4;
   */
  purchaseCurrency = "";

  /**
   * @generated from field: string purchaseDate = 5;
   */
  purchaseDate = "";

  /**
   * @generated from field: string timeout = 6;
   */
  timeout = "";

  constructor(data?: PartialMessage<PendingThreeDSConfirmation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PendingThreeDSConfirmation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transactionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchantName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchaseAmount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "purchaseCurrency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "purchaseDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timeout", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PendingThreeDSConfirmation {
    return new PendingThreeDSConfirmation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PendingThreeDSConfirmation {
    return new PendingThreeDSConfirmation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PendingThreeDSConfirmation {
    return new PendingThreeDSConfirmation().fromJsonString(jsonString, options);
  }

  static equals(a: PendingThreeDSConfirmation | PlainMessage<PendingThreeDSConfirmation> | undefined, b: PendingThreeDSConfirmation | PlainMessage<PendingThreeDSConfirmation> | undefined): boolean {
    return proto3.util.equals(PendingThreeDSConfirmation, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPendingThreeDSConfirmationsResponse
 */
export class GetPendingThreeDSConfirmationsResponse extends Message<GetPendingThreeDSConfirmationsResponse> {
  /**
   * @generated from field: repeated backend.v1.PendingThreeDSConfirmation confirmations = 1;
   */
  confirmations: PendingThreeDSConfirmation[] = [];

  constructor(data?: PartialMessage<GetPendingThreeDSConfirmationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPendingThreeDSConfirmationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "confirmations", kind: "message", T: PendingThreeDSConfirmation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPendingThreeDSConfirmationsResponse {
    return new GetPendingThreeDSConfirmationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPendingThreeDSConfirmationsResponse {
    return new GetPendingThreeDSConfirmationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPendingThreeDSConfirmationsResponse {
    return new GetPendingThreeDSConfirmationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPendingThreeDSConfirmationsResponse | PlainMessage<GetPendingThreeDSConfirmationsResponse> | undefined, b: GetPendingThreeDSConfirmationsResponse | PlainMessage<GetPendingThreeDSConfirmationsResponse> | undefined): boolean {
    return proto3.util.equals(GetPendingThreeDSConfirmationsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.FreezeCardRequest
 */
export class FreezeCardRequest extends Message<FreezeCardRequest> {
  /**
   * @generated from field: string cardId = 1;
   */
  cardId = "";

  constructor(data?: PartialMessage<FreezeCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.FreezeCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cardId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FreezeCardRequest {
    return new FreezeCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FreezeCardRequest {
    return new FreezeCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FreezeCardRequest {
    return new FreezeCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FreezeCardRequest | PlainMessage<FreezeCardRequest> | undefined, b: FreezeCardRequest | PlainMessage<FreezeCardRequest> | undefined): boolean {
    return proto3.util.equals(FreezeCardRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.UnfreezeCardRequest
 */
export class UnfreezeCardRequest extends Message<UnfreezeCardRequest> {
  /**
   * @generated from field: string cardId = 1;
   */
  cardId = "";

  constructor(data?: PartialMessage<UnfreezeCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.UnfreezeCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cardId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnfreezeCardRequest {
    return new UnfreezeCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnfreezeCardRequest {
    return new UnfreezeCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnfreezeCardRequest {
    return new UnfreezeCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnfreezeCardRequest | PlainMessage<UnfreezeCardRequest> | undefined, b: UnfreezeCardRequest | PlainMessage<UnfreezeCardRequest> | undefined): boolean {
    return proto3.util.equals(UnfreezeCardRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.BlockCardRequest
 */
export class BlockCardRequest extends Message<BlockCardRequest> {
  /**
   * @generated from field: string cardId = 1;
   */
  cardId = "";

  constructor(data?: PartialMessage<BlockCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.BlockCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cardId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockCardRequest {
    return new BlockCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockCardRequest {
    return new BlockCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockCardRequest {
    return new BlockCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BlockCardRequest | PlainMessage<BlockCardRequest> | undefined, b: BlockCardRequest | PlainMessage<BlockCardRequest> | undefined): boolean {
    return proto3.util.equals(BlockCardRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.TokenLink
 */
export class TokenLink extends Message<TokenLink> {
  /**
   * @generated from field: string href = 1;
   */
  href = "";

  /**
   * @generated from field: string rel = 2;
   */
  rel = "";

  /**
   * @generated from field: string method = 3;
   */
  method = "";

  constructor(data?: PartialMessage<TokenLink>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.TokenLink";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rel", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TokenLink {
    return new TokenLink().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TokenLink {
    return new TokenLink().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TokenLink {
    return new TokenLink().fromJsonString(jsonString, options);
  }

  static equals(a: TokenLink | PlainMessage<TokenLink> | undefined, b: TokenLink | PlainMessage<TokenLink> | undefined): boolean {
    return proto3.util.equals(TokenLink, a, b);
  }
}

/**
 * @generated from message backend.v1.GetCardTokenRequest
 */
export class GetCardTokenRequest extends Message<GetCardTokenRequest> {
  /**
   * @generated from field: backend.v1.CardTokenType tokenType = 1;
   */
  tokenType = CardTokenType.PIN;

  /**
   * @generated from field: string cardId = 2;
   */
  cardId = "";

  /**
   * @generated from field: optional string publicKey = 3;
   */
  publicKey?: string;

  constructor(data?: PartialMessage<GetCardTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetCardTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tokenType", kind: "enum", T: proto3.getEnumType(CardTokenType) },
    { no: 2, name: "cardId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "publicKey", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCardTokenRequest {
    return new GetCardTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCardTokenRequest {
    return new GetCardTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCardTokenRequest {
    return new GetCardTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCardTokenRequest | PlainMessage<GetCardTokenRequest> | undefined, b: GetCardTokenRequest | PlainMessage<GetCardTokenRequest> | undefined): boolean {
    return proto3.util.equals(GetCardTokenRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetCardTokenResponse
 */
export class GetCardTokenResponse extends Message<GetCardTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: repeated backend.v1.TokenLink links = 2;
   */
  links: TokenLink[] = [];

  constructor(data?: PartialMessage<GetCardTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetCardTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "links", kind: "message", T: TokenLink, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCardTokenResponse {
    return new GetCardTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCardTokenResponse {
    return new GetCardTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCardTokenResponse {
    return new GetCardTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCardTokenResponse | PlainMessage<GetCardTokenResponse> | undefined, b: GetCardTokenResponse | PlainMessage<GetCardTokenResponse> | undefined): boolean {
    return proto3.util.equals(GetCardTokenResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetCardOrderOptionsResponse
 */
export class GetCardOrderOptionsResponse extends Message<GetCardOrderOptionsResponse> {
  /**
   * @generated from field: bool isWaitingForCreation = 1;
   */
  isWaitingForCreation = false;

  /**
   * @generated from field: repeated backend.v1.CardApplicationProduct products = 2;
   */
  products: CardApplicationProduct[] = [];

  /**
   * @generated from field: repeated backend.v1.CustomerDeliveryAddress addresses = 3;
   */
  addresses: CustomerDeliveryAddress[] = [];

  /**
   * @generated from field: repeated backend.v1.Country countries = 4;
   */
  countries: Country[] = [];

  constructor(data?: PartialMessage<GetCardOrderOptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetCardOrderOptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "isWaitingForCreation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "products", kind: "message", T: CardApplicationProduct, repeated: true },
    { no: 3, name: "addresses", kind: "message", T: CustomerDeliveryAddress, repeated: true },
    { no: 4, name: "countries", kind: "message", T: Country, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCardOrderOptionsResponse {
    return new GetCardOrderOptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCardOrderOptionsResponse {
    return new GetCardOrderOptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCardOrderOptionsResponse {
    return new GetCardOrderOptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCardOrderOptionsResponse | PlainMessage<GetCardOrderOptionsResponse> | undefined, b: GetCardOrderOptionsResponse | PlainMessage<GetCardOrderOptionsResponse> | undefined): boolean {
    return proto3.util.equals(GetCardOrderOptionsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.OrderCardRequest
 */
export class OrderCardRequest extends Message<OrderCardRequest> {
  /**
   * @generated from field: backend.v1.CardType type = 1;
   */
  type = CardType.UNKNOWN;

  /**
   * @generated from field: string cardProductCode = 2;
   */
  cardProductCode = "";

  /**
   * @generated from oneof backend.v1.OrderCardRequest.deliveryAddress
   */
  deliveryAddress: {
    /**
     * @generated from field: string deliveryAddressId = 3;
     */
    value: string;
    case: "deliveryAddressId";
  } | {
    /**
     * @generated from field: backend.v1.NewCustomerDeliveryAddress newDeliveryAddress = 4;
     */
    value: NewCustomerDeliveryAddress;
    case: "newDeliveryAddress";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<OrderCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.OrderCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(CardType) },
    { no: 2, name: "cardProductCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deliveryAddressId", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "deliveryAddress" },
    { no: 4, name: "newDeliveryAddress", kind: "message", T: NewCustomerDeliveryAddress, oneof: "deliveryAddress" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OrderCardRequest {
    return new OrderCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OrderCardRequest {
    return new OrderCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OrderCardRequest {
    return new OrderCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OrderCardRequest | PlainMessage<OrderCardRequest> | undefined, b: OrderCardRequest | PlainMessage<OrderCardRequest> | undefined): boolean {
    return proto3.util.equals(OrderCardRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CardApplicationProduct
 */
export class CardApplicationProduct extends Message<CardApplicationProduct> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<CardApplicationProduct>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CardApplicationProduct";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CardApplicationProduct {
    return new CardApplicationProduct().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CardApplicationProduct {
    return new CardApplicationProduct().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CardApplicationProduct {
    return new CardApplicationProduct().fromJsonString(jsonString, options);
  }

  static equals(a: CardApplicationProduct | PlainMessage<CardApplicationProduct> | undefined, b: CardApplicationProduct | PlainMessage<CardApplicationProduct> | undefined): boolean {
    return proto3.util.equals(CardApplicationProduct, a, b);
  }
}

/**
 * @generated from message backend.v1.CustomerDeliveryAddressBase
 */
export class CustomerDeliveryAddressBase extends Message<CustomerDeliveryAddressBase> {
  /**
   * @generated from field: backend.v1.CustomerDeliveryAddressType type = 1;
   */
  type = CustomerDeliveryAddressType.CUSTOMER_DELIVERY_ADDRESS_OTHER;

  /**
   * @generated from field: string countryCode = 2;
   */
  countryCode = "";

  /**
   * @generated from field: string line1 = 3;
   */
  line1 = "";

  /**
   * @generated from field: optional string line2 = 4;
   */
  line2?: string;

  /**
   * @generated from field: optional string line3 = 5;
   */
  line3?: string;

  /**
   * @generated from field: optional string postOffice = 6;
   */
  postOffice?: string;

  /**
   * @generated from field: string city = 7;
   */
  city = "";

  /**
   * @generated from field: string zipCode = 8;
   */
  zipCode = "";

  constructor(data?: PartialMessage<CustomerDeliveryAddressBase>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CustomerDeliveryAddressBase";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(CustomerDeliveryAddressType) },
    { no: 2, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "line2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "line3", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "postOffice", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "zipCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CustomerDeliveryAddressBase {
    return new CustomerDeliveryAddressBase().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CustomerDeliveryAddressBase {
    return new CustomerDeliveryAddressBase().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CustomerDeliveryAddressBase {
    return new CustomerDeliveryAddressBase().fromJsonString(jsonString, options);
  }

  static equals(a: CustomerDeliveryAddressBase | PlainMessage<CustomerDeliveryAddressBase> | undefined, b: CustomerDeliveryAddressBase | PlainMessage<CustomerDeliveryAddressBase> | undefined): boolean {
    return proto3.util.equals(CustomerDeliveryAddressBase, a, b);
  }
}

/**
 * @generated from message backend.v1.CustomerDeliveryAddress
 */
export class CustomerDeliveryAddress extends Message<CustomerDeliveryAddress> {
  /**
   * @generated from field: backend.v1.CustomerDeliveryAddressBase details = 1;
   */
  details?: CustomerDeliveryAddressBase;

  /**
   * @generated from field: string id = 2;
   */
  id = "";

  constructor(data?: PartialMessage<CustomerDeliveryAddress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CustomerDeliveryAddress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "details", kind: "message", T: CustomerDeliveryAddressBase },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CustomerDeliveryAddress {
    return new CustomerDeliveryAddress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CustomerDeliveryAddress {
    return new CustomerDeliveryAddress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CustomerDeliveryAddress {
    return new CustomerDeliveryAddress().fromJsonString(jsonString, options);
  }

  static equals(a: CustomerDeliveryAddress | PlainMessage<CustomerDeliveryAddress> | undefined, b: CustomerDeliveryAddress | PlainMessage<CustomerDeliveryAddress> | undefined): boolean {
    return proto3.util.equals(CustomerDeliveryAddress, a, b);
  }
}

/**
 * @generated from message backend.v1.NewCustomerDeliveryAddress
 */
export class NewCustomerDeliveryAddress extends Message<NewCustomerDeliveryAddress> {
  /**
   * @generated from field: backend.v1.CustomerDeliveryAddressBase details = 1;
   */
  details?: CustomerDeliveryAddressBase;

  /**
   * @generated from field: string reason = 2;
   */
  reason = "";

  constructor(data?: PartialMessage<NewCustomerDeliveryAddress>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.NewCustomerDeliveryAddress";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "details", kind: "message", T: CustomerDeliveryAddressBase },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NewCustomerDeliveryAddress {
    return new NewCustomerDeliveryAddress().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NewCustomerDeliveryAddress {
    return new NewCustomerDeliveryAddress().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NewCustomerDeliveryAddress {
    return new NewCustomerDeliveryAddress().fromJsonString(jsonString, options);
  }

  static equals(a: NewCustomerDeliveryAddress | PlainMessage<NewCustomerDeliveryAddress> | undefined, b: NewCustomerDeliveryAddress | PlainMessage<NewCustomerDeliveryAddress> | undefined): boolean {
    return proto3.util.equals(NewCustomerDeliveryAddress, a, b);
  }
}

/**
 * @generated from message backend.v1.Card
 */
export class Card extends Message<Card> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string nameOnCard = 2;
   */
  nameOnCard = "";

  /**
   * @generated from field: string maskedPan = 3;
   */
  maskedPan = "";

  /**
   * @generated from field: backend.v1.CardStatus status = 4;
   */
  status = CardStatus.UNKNOWN;

  /**
   * @generated from field: backend.v1.CardStatusReasonCode statusReasonCode = 5;
   */
  statusReasonCode = CardStatusReasonCode.UNKNOWN;

  /**
   * @generated from field: backend.v1.CardLockLevel lockLevel = 6;
   */
  lockLevel = CardLockLevel.UNKNOWN;

  /**
   * @generated from field: string expiryDate = 7;
   */
  expiryDate = "";

  /**
   * @generated from field: backend.v1.CardType type = 8;
   */
  type = CardType.UNKNOWN;

  /**
   * @generated from field: string productCode = 9;
   */
  productCode = "";

  constructor(data?: PartialMessage<Card>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Card";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nameOnCard", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "maskedPan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(CardStatus) },
    { no: 5, name: "statusReasonCode", kind: "enum", T: proto3.getEnumType(CardStatusReasonCode) },
    { no: 6, name: "lockLevel", kind: "enum", T: proto3.getEnumType(CardLockLevel) },
    { no: 7, name: "expiryDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(CardType) },
    { no: 9, name: "productCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Card {
    return new Card().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Card {
    return new Card().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Card {
    return new Card().fromJsonString(jsonString, options);
  }

  static equals(a: Card | PlainMessage<Card> | undefined, b: Card | PlainMessage<Card> | undefined): boolean {
    return proto3.util.equals(Card, a, b);
  }
}

/**
 * @generated from message backend.v1.ListCardsResponse
 */
export class ListCardsResponse extends Message<ListCardsResponse> {
  /**
   * @generated from field: bool isWaitingForCreation = 1;
   */
  isWaitingForCreation = false;

  /**
   * @generated from field: repeated backend.v1.Card cards = 2;
   */
  cards: Card[] = [];

  constructor(data?: PartialMessage<ListCardsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListCardsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "isWaitingForCreation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "cards", kind: "message", T: Card, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCardsResponse {
    return new ListCardsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCardsResponse {
    return new ListCardsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCardsResponse {
    return new ListCardsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCardsResponse | PlainMessage<ListCardsResponse> | undefined, b: ListCardsResponse | PlainMessage<ListCardsResponse> | undefined): boolean {
    return proto3.util.equals(ListCardsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreatePtiBankAccountRequest
 */
export class CreatePtiBankAccountRequest extends Message<CreatePtiBankAccountRequest> {
  /**
   * @generated from field: string bankName = 1;
   */
  bankName = "";

  /**
   * @generated from field: string accountNumber = 2;
   */
  accountNumber = "";

  /**
   * @generated from field: string routingNumber = 3;
   */
  routingNumber = "";

  /**
   * @generated from field: string accountType = 4;
   */
  accountType = "";

  constructor(data?: PartialMessage<CreatePtiBankAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreatePtiBankAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bankName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "accountNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "routingNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "accountType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePtiBankAccountRequest {
    return new CreatePtiBankAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePtiBankAccountRequest {
    return new CreatePtiBankAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePtiBankAccountRequest {
    return new CreatePtiBankAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePtiBankAccountRequest | PlainMessage<CreatePtiBankAccountRequest> | undefined, b: CreatePtiBankAccountRequest | PlainMessage<CreatePtiBankAccountRequest> | undefined): boolean {
    return proto3.util.equals(CreatePtiBankAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.PtiTokenRequest
 */
export class PtiTokenRequest extends Message<PtiTokenRequest> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string method = 2;
   */
  method = "";

  constructor(data?: PartialMessage<PtiTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PtiTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PtiTokenRequest {
    return new PtiTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PtiTokenRequest {
    return new PtiTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PtiTokenRequest {
    return new PtiTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PtiTokenRequest | PlainMessage<PtiTokenRequest> | undefined, b: PtiTokenRequest | PlainMessage<PtiTokenRequest> | undefined): boolean {
    return proto3.util.equals(PtiTokenRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.PtiTokenResponse
 */
export class PtiTokenResponse extends Message<PtiTokenResponse> {
  /**
   * @generated from field: string accessToken = 1;
   */
  accessToken = "";

  /**
   * @generated from field: double expiresAt = 2;
   */
  expiresAt = 0;

  /**
   * @generated from field: string tokenType = 3;
   */
  tokenType = "";

  constructor(data?: PartialMessage<PtiTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PtiTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accessToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expiresAt", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "tokenType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PtiTokenResponse {
    return new PtiTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PtiTokenResponse {
    return new PtiTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PtiTokenResponse {
    return new PtiTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PtiTokenResponse | PlainMessage<PtiTokenResponse> | undefined, b: PtiTokenResponse | PlainMessage<PtiTokenResponse> | undefined): boolean {
    return proto3.util.equals(PtiTokenResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateChimoneyDepositRequest
 */
export class CreateChimoneyDepositRequest extends Message<CreateChimoneyDepositRequest> {
  /**
   * @generated from field: string issueId = 1;
   */
  issueId = "";

  constructor(data?: PartialMessage<CreateChimoneyDepositRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateChimoneyDepositRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issueId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateChimoneyDepositRequest {
    return new CreateChimoneyDepositRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateChimoneyDepositRequest {
    return new CreateChimoneyDepositRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateChimoneyDepositRequest {
    return new CreateChimoneyDepositRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateChimoneyDepositRequest | PlainMessage<CreateChimoneyDepositRequest> | undefined, b: CreateChimoneyDepositRequest | PlainMessage<CreateChimoneyDepositRequest> | undefined): boolean {
    return proto3.util.equals(CreateChimoneyDepositRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetChimoneyDepositLinkResponse
 */
export class GetChimoneyDepositLinkResponse extends Message<GetChimoneyDepositLinkResponse> {
  /**
   * @generated from field: string link = 1;
   */
  link = "";

  constructor(data?: PartialMessage<GetChimoneyDepositLinkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetChimoneyDepositLinkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetChimoneyDepositLinkResponse {
    return new GetChimoneyDepositLinkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetChimoneyDepositLinkResponse {
    return new GetChimoneyDepositLinkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetChimoneyDepositLinkResponse {
    return new GetChimoneyDepositLinkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetChimoneyDepositLinkResponse | PlainMessage<GetChimoneyDepositLinkResponse> | undefined, b: GetChimoneyDepositLinkResponse | PlainMessage<GetChimoneyDepositLinkResponse> | undefined): boolean {
    return proto3.util.equals(GetChimoneyDepositLinkResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.ChimoneyInterlocEmail
 */
export class ChimoneyInterlocEmail extends Message<ChimoneyInterlocEmail> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<ChimoneyInterlocEmail>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ChimoneyInterlocEmail";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChimoneyInterlocEmail {
    return new ChimoneyInterlocEmail().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChimoneyInterlocEmail {
    return new ChimoneyInterlocEmail().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChimoneyInterlocEmail {
    return new ChimoneyInterlocEmail().fromJsonString(jsonString, options);
  }

  static equals(a: ChimoneyInterlocEmail | PlainMessage<ChimoneyInterlocEmail> | undefined, b: ChimoneyInterlocEmail | PlainMessage<ChimoneyInterlocEmail> | undefined): boolean {
    return proto3.util.equals(ChimoneyInterlocEmail, a, b);
  }
}

/**
 * @generated from message backend.v1.SetChimoneyInterlocEmailRequest
 */
export class SetChimoneyInterlocEmailRequest extends Message<SetChimoneyInterlocEmailRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<SetChimoneyInterlocEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetChimoneyInterlocEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetChimoneyInterlocEmailRequest {
    return new SetChimoneyInterlocEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetChimoneyInterlocEmailRequest {
    return new SetChimoneyInterlocEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetChimoneyInterlocEmailRequest {
    return new SetChimoneyInterlocEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetChimoneyInterlocEmailRequest | PlainMessage<SetChimoneyInterlocEmailRequest> | undefined, b: SetChimoneyInterlocEmailRequest | PlainMessage<SetChimoneyInterlocEmailRequest> | undefined): boolean {
    return proto3.util.equals(SetChimoneyInterlocEmailRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateGatehubWithdrawalRequest
 */
export class CreateGatehubWithdrawalRequest extends Message<CreateGatehubWithdrawalRequest> {
  /**
   * @generated from field: string externalTransactionId = 1;
   */
  externalTransactionId = "";

  constructor(data?: PartialMessage<CreateGatehubWithdrawalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateGatehubWithdrawalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "externalTransactionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateGatehubWithdrawalRequest {
    return new CreateGatehubWithdrawalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateGatehubWithdrawalRequest {
    return new CreateGatehubWithdrawalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateGatehubWithdrawalRequest {
    return new CreateGatehubWithdrawalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateGatehubWithdrawalRequest | PlainMessage<CreateGatehubWithdrawalRequest> | undefined, b: CreateGatehubWithdrawalRequest | PlainMessage<CreateGatehubWithdrawalRequest> | undefined): boolean {
    return proto3.util.equals(CreateGatehubWithdrawalRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateGatehubWithdrawalResponse
 */
export class CreateGatehubWithdrawalResponse extends Message<CreateGatehubWithdrawalResponse> {
  /**
   * @generated from field: string transactionId = 1;
   */
  transactionId = "";

  constructor(data?: PartialMessage<CreateGatehubWithdrawalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateGatehubWithdrawalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transactionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateGatehubWithdrawalResponse {
    return new CreateGatehubWithdrawalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateGatehubWithdrawalResponse {
    return new CreateGatehubWithdrawalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateGatehubWithdrawalResponse {
    return new CreateGatehubWithdrawalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateGatehubWithdrawalResponse | PlainMessage<CreateGatehubWithdrawalResponse> | undefined, b: CreateGatehubWithdrawalResponse | PlainMessage<CreateGatehubWithdrawalResponse> | undefined): boolean {
    return proto3.util.equals(CreateGatehubWithdrawalResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreatePTIWithdrawalRequest
 */
export class CreatePTIWithdrawalRequest extends Message<CreatePTIWithdrawalRequest> {
  /**
   * @generated from field: string paymentId = 1;
   */
  paymentId = "";

  constructor(data?: PartialMessage<CreatePTIWithdrawalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreatePTIWithdrawalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "paymentId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePTIWithdrawalRequest {
    return new CreatePTIWithdrawalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePTIWithdrawalRequest {
    return new CreatePTIWithdrawalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePTIWithdrawalRequest {
    return new CreatePTIWithdrawalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePTIWithdrawalRequest | PlainMessage<CreatePTIWithdrawalRequest> | undefined, b: CreatePTIWithdrawalRequest | PlainMessage<CreatePTIWithdrawalRequest> | undefined): boolean {
    return proto3.util.equals(CreatePTIWithdrawalRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CreatePTIWithdrawalResponse
 */
export class CreatePTIWithdrawalResponse extends Message<CreatePTIWithdrawalResponse> {
  /**
   * @generated from field: string paymentId = 1;
   */
  paymentId = "";

  constructor(data?: PartialMessage<CreatePTIWithdrawalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreatePTIWithdrawalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "paymentId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePTIWithdrawalResponse {
    return new CreatePTIWithdrawalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePTIWithdrawalResponse {
    return new CreatePTIWithdrawalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePTIWithdrawalResponse {
    return new CreatePTIWithdrawalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePTIWithdrawalResponse | PlainMessage<CreatePTIWithdrawalResponse> | undefined, b: CreatePTIWithdrawalResponse | PlainMessage<CreatePTIWithdrawalResponse> | undefined): boolean {
    return proto3.util.equals(CreatePTIWithdrawalResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetOnOffRampProviderResponse
 */
export class GetOnOffRampProviderResponse extends Message<GetOnOffRampProviderResponse> {
  /**
   * @generated from field: string provider = 1;
   */
  provider = "";

  constructor(data?: PartialMessage<GetOnOffRampProviderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetOnOffRampProviderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOnOffRampProviderResponse {
    return new GetOnOffRampProviderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOnOffRampProviderResponse {
    return new GetOnOffRampProviderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOnOffRampProviderResponse {
    return new GetOnOffRampProviderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOnOffRampProviderResponse | PlainMessage<GetOnOffRampProviderResponse> | undefined, b: GetOnOffRampProviderResponse | PlainMessage<GetOnOffRampProviderResponse> | undefined): boolean {
    return proto3.util.equals(GetOnOffRampProviderResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetKYCProviderWidgetRequest
 */
export class GetKYCProviderWidgetRequest extends Message<GetKYCProviderWidgetRequest> {
  /**
   * @generated from field: string idempotencyKey = 1;
   */
  idempotencyKey = "";

  constructor(data?: PartialMessage<GetKYCProviderWidgetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetKYCProviderWidgetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "idempotencyKey", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetKYCProviderWidgetRequest {
    return new GetKYCProviderWidgetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetKYCProviderWidgetRequest {
    return new GetKYCProviderWidgetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetKYCProviderWidgetRequest {
    return new GetKYCProviderWidgetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetKYCProviderWidgetRequest | PlainMessage<GetKYCProviderWidgetRequest> | undefined, b: GetKYCProviderWidgetRequest | PlainMessage<GetKYCProviderWidgetRequest> | undefined): boolean {
    return proto3.util.equals(GetKYCProviderWidgetRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.KYCProviderWidget
 */
export class KYCProviderWidget extends Message<KYCProviderWidget> {
  /**
   * @generated from field: string provider = 1;
   */
  provider = "";

  /**
   * @generated from field: backend.v1.GatehubWidget gatehubWidget = 2;
   */
  gatehubWidget?: GatehubWidget;

  /**
   * @generated from field: backend.v1.KYCPersonaInquiryResponse personaInquiry = 3;
   */
  personaInquiry?: KYCPersonaInquiryResponse;

  /**
   * @generated from field: string chimoneyWidget = 4;
   */
  chimoneyWidget = "";

  /**
   * @generated from field: backend.v1.PtiWidget ptiWidget = 5;
   */
  ptiWidget?: PtiWidget;

  constructor(data?: PartialMessage<KYCProviderWidget>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.KYCProviderWidget";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "gatehubWidget", kind: "message", T: GatehubWidget },
    { no: 3, name: "personaInquiry", kind: "message", T: KYCPersonaInquiryResponse },
    { no: 4, name: "chimoneyWidget", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ptiWidget", kind: "message", T: PtiWidget },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KYCProviderWidget {
    return new KYCProviderWidget().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KYCProviderWidget {
    return new KYCProviderWidget().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KYCProviderWidget {
    return new KYCProviderWidget().fromJsonString(jsonString, options);
  }

  static equals(a: KYCProviderWidget | PlainMessage<KYCProviderWidget> | undefined, b: KYCProviderWidget | PlainMessage<KYCProviderWidget> | undefined): boolean {
    return proto3.util.equals(KYCProviderWidget, a, b);
  }
}

/**
 * @generated from message backend.v1.PtiWidget
 */
export class PtiWidget extends Message<PtiWidget> {
  /**
   * @generated from field: string scenarioId = 1;
   */
  scenarioId = "";

  /**
   * @generated from field: string userId = 2;
   */
  userId = "";

  /**
   * @generated from field: string requestId = 3;
   */
  requestId = "";

  /**
   * @generated from field: string clientId = 4;
   */
  clientId = "";

  /**
   * @generated from field: string generateTokenPath = 5;
   */
  generateTokenPath = "";

  /**
   * @generated from field: string sdkUrl = 6;
   */
  sdkUrl = "";

  /**
   * @generated from field: string formsUrl = 7;
   */
  formsUrl = "";

  constructor(data?: PartialMessage<PtiWidget>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PtiWidget";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scenarioId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "userId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "requestId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "clientId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "generateTokenPath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "sdkUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "formsUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PtiWidget {
    return new PtiWidget().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PtiWidget {
    return new PtiWidget().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PtiWidget {
    return new PtiWidget().fromJsonString(jsonString, options);
  }

  static equals(a: PtiWidget | PlainMessage<PtiWidget> | undefined, b: PtiWidget | PlainMessage<PtiWidget> | undefined): boolean {
    return proto3.util.equals(PtiWidget, a, b);
  }
}

/**
 * @generated from message backend.v1.GatehubWidget
 */
export class GatehubWidget extends Message<GatehubWidget> {
  /**
   * @generated from field: string widgetUrl = 1;
   */
  widgetUrl = "";

  constructor(data?: PartialMessage<GatehubWidget>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GatehubWidget";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "widgetUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GatehubWidget {
    return new GatehubWidget().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GatehubWidget {
    return new GatehubWidget().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GatehubWidget {
    return new GatehubWidget().fromJsonString(jsonString, options);
  }

  static equals(a: GatehubWidget | PlainMessage<GatehubWidget> | undefined, b: GatehubWidget | PlainMessage<GatehubWidget> | undefined): boolean {
    return proto3.util.equals(GatehubWidget, a, b);
  }
}

/**
 * @generated from message backend.v1.RevokeRafikiGrantRequest
 */
export class RevokeRafikiGrantRequest extends Message<RevokeRafikiGrantRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<RevokeRafikiGrantRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.RevokeRafikiGrantRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RevokeRafikiGrantRequest {
    return new RevokeRafikiGrantRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RevokeRafikiGrantRequest {
    return new RevokeRafikiGrantRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RevokeRafikiGrantRequest {
    return new RevokeRafikiGrantRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RevokeRafikiGrantRequest | PlainMessage<RevokeRafikiGrantRequest> | undefined, b: RevokeRafikiGrantRequest | PlainMessage<RevokeRafikiGrantRequest> | undefined): boolean {
    return proto3.util.equals(RevokeRafikiGrantRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetRafikiGrantRequest
 */
export class GetRafikiGrantRequest extends Message<GetRafikiGrantRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetRafikiGrantRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetRafikiGrantRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRafikiGrantRequest {
    return new GetRafikiGrantRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRafikiGrantRequest {
    return new GetRafikiGrantRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRafikiGrantRequest {
    return new GetRafikiGrantRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRafikiGrantRequest | PlainMessage<GetRafikiGrantRequest> | undefined, b: GetRafikiGrantRequest | PlainMessage<GetRafikiGrantRequest> | undefined): boolean {
    return proto3.util.equals(GetRafikiGrantRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.ListRafikiGrantsResponse
 */
export class ListRafikiGrantsResponse extends Message<ListRafikiGrantsResponse> {
  /**
   * @generated from field: repeated backend.v1.RafikiGrant grants = 1;
   */
  grants: RafikiGrant[] = [];

  constructor(data?: PartialMessage<ListRafikiGrantsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListRafikiGrantsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "grants", kind: "message", T: RafikiGrant, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRafikiGrantsResponse {
    return new ListRafikiGrantsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRafikiGrantsResponse {
    return new ListRafikiGrantsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRafikiGrantsResponse {
    return new ListRafikiGrantsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRafikiGrantsResponse | PlainMessage<ListRafikiGrantsResponse> | undefined, b: ListRafikiGrantsResponse | PlainMessage<ListRafikiGrantsResponse> | undefined): boolean {
    return proto3.util.equals(ListRafikiGrantsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.RafikiGrant
 */
export class RafikiGrant extends Message<RafikiGrant> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string client = 2;
   */
  client = "";

  /**
   * @generated from field: string state = 3;
   */
  state = "";

  /**
   * @generated from field: string finalizationReason = 4;
   */
  finalizationReason = "";

  /**
   * @generated from field: string createdAt = 5;
   */
  createdAt = "";

  /**
   * @generated from field: repeated backend.v1.RafikiAccess access = 6;
   */
  access: RafikiAccess[] = [];

  constructor(data?: PartialMessage<RafikiGrant>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.RafikiGrant";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "client", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "finalizationReason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "createdAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "access", kind: "message", T: RafikiAccess, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RafikiGrant {
    return new RafikiGrant().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RafikiGrant {
    return new RafikiGrant().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RafikiGrant {
    return new RafikiGrant().fromJsonString(jsonString, options);
  }

  static equals(a: RafikiGrant | PlainMessage<RafikiGrant> | undefined, b: RafikiGrant | PlainMessage<RafikiGrant> | undefined): boolean {
    return proto3.util.equals(RafikiGrant, a, b);
  }
}

/**
 * @generated from message backend.v1.RafikiAccess
 */
export class RafikiAccess extends Message<RafikiAccess> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string identifier = 2;
   */
  identifier = "";

  /**
   * @generated from field: string type = 3;
   */
  type = "";

  /**
   * @generated from field: repeated string actions = 4;
   */
  actions: string[] = [];

  /**
   * @generated from field: backend.v1.RafikiLimits limits = 5;
   */
  limits?: RafikiLimits;

  constructor(data?: PartialMessage<RafikiAccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.RafikiAccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "actions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "limits", kind: "message", T: RafikiLimits },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RafikiAccess {
    return new RafikiAccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RafikiAccess {
    return new RafikiAccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RafikiAccess {
    return new RafikiAccess().fromJsonString(jsonString, options);
  }

  static equals(a: RafikiAccess | PlainMessage<RafikiAccess> | undefined, b: RafikiAccess | PlainMessage<RafikiAccess> | undefined): boolean {
    return proto3.util.equals(RafikiAccess, a, b);
  }
}

/**
 * @generated from message backend.v1.RafikiLimits
 */
export class RafikiLimits extends Message<RafikiLimits> {
  /**
   * @generated from field: string receiver = 1;
   */
  receiver = "";

  /**
   * @generated from field: string interval = 2;
   */
  interval = "";

  /**
   * @generated from field: backend.v1.Amount debitAmount = 3;
   */
  debitAmount?: Amount;

  /**
   * @generated from field: backend.v1.Amount receiveAmount = 4;
   */
  receiveAmount?: Amount;

  /**
   * @generated from field: string formattedDebitAmount = 5;
   */
  formattedDebitAmount = "";

  /**
   * @generated from field: string formattdReceiveAmount = 6;
   */
  formattdReceiveAmount = "";

  constructor(data?: PartialMessage<RafikiLimits>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.RafikiLimits";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "receiver", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "interval", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "debitAmount", kind: "message", T: Amount },
    { no: 4, name: "receiveAmount", kind: "message", T: Amount },
    { no: 5, name: "formattedDebitAmount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "formattdReceiveAmount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RafikiLimits {
    return new RafikiLimits().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RafikiLimits {
    return new RafikiLimits().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RafikiLimits {
    return new RafikiLimits().fromJsonString(jsonString, options);
  }

  static equals(a: RafikiLimits | PlainMessage<RafikiLimits> | undefined, b: RafikiLimits | PlainMessage<RafikiLimits> | undefined): boolean {
    return proto3.util.equals(RafikiLimits, a, b);
  }
}

/**
 * @generated from message backend.v1.GetLinkedAccountsForTransferRequest
 */
export class GetLinkedAccountsForTransferRequest extends Message<GetLinkedAccountsForTransferRequest> {
  /**
   * The ID of the linked account for the balance to deposit to/withdraw from.
   *
   * @generated from field: string linkedAccountId = 1;
   */
  linkedAccountId = "";

  constructor(data?: PartialMessage<GetLinkedAccountsForTransferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetLinkedAccountsForTransferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "linkedAccountId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLinkedAccountsForTransferRequest {
    return new GetLinkedAccountsForTransferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLinkedAccountsForTransferRequest {
    return new GetLinkedAccountsForTransferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLinkedAccountsForTransferRequest {
    return new GetLinkedAccountsForTransferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLinkedAccountsForTransferRequest | PlainMessage<GetLinkedAccountsForTransferRequest> | undefined, b: GetLinkedAccountsForTransferRequest | PlainMessage<GetLinkedAccountsForTransferRequest> | undefined): boolean {
    return proto3.util.equals(GetLinkedAccountsForTransferRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetLinkedAccountsForPaymentRequest
 */
export class GetLinkedAccountsForPaymentRequest extends Message<GetLinkedAccountsForPaymentRequest> {
  /**
   * @generated from field: string paymentId = 1;
   */
  paymentId = "";

  constructor(data?: PartialMessage<GetLinkedAccountsForPaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetLinkedAccountsForPaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "paymentId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLinkedAccountsForPaymentRequest {
    return new GetLinkedAccountsForPaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLinkedAccountsForPaymentRequest {
    return new GetLinkedAccountsForPaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLinkedAccountsForPaymentRequest {
    return new GetLinkedAccountsForPaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLinkedAccountsForPaymentRequest | PlainMessage<GetLinkedAccountsForPaymentRequest> | undefined, b: GetLinkedAccountsForPaymentRequest | PlainMessage<GetLinkedAccountsForPaymentRequest> | undefined): boolean {
    return proto3.util.equals(GetLinkedAccountsForPaymentRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetLinkedAccountsForPaymentResponse
 */
export class GetLinkedAccountsForPaymentResponse extends Message<GetLinkedAccountsForPaymentResponse> {
  /**
   * @generated from field: repeated backend.v1.LinkedAccountForPayment linkedAccounts = 1;
   */
  linkedAccounts: LinkedAccountForPayment[] = [];

  constructor(data?: PartialMessage<GetLinkedAccountsForPaymentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetLinkedAccountsForPaymentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "linkedAccounts", kind: "message", T: LinkedAccountForPayment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLinkedAccountsForPaymentResponse {
    return new GetLinkedAccountsForPaymentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLinkedAccountsForPaymentResponse {
    return new GetLinkedAccountsForPaymentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLinkedAccountsForPaymentResponse {
    return new GetLinkedAccountsForPaymentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLinkedAccountsForPaymentResponse | PlainMessage<GetLinkedAccountsForPaymentResponse> | undefined, b: GetLinkedAccountsForPaymentResponse | PlainMessage<GetLinkedAccountsForPaymentResponse> | undefined): boolean {
    return proto3.util.equals(GetLinkedAccountsForPaymentResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.LinkedAccountForPayment
 */
export class LinkedAccountForPayment extends Message<LinkedAccountForPayment> {
  /**
   * @generated from field: backend.v1.LinkedAccount details = 1;
   */
  details?: LinkedAccount;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled = false;

  constructor(data?: PartialMessage<LinkedAccountForPayment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.LinkedAccountForPayment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "details", kind: "message", T: LinkedAccount },
    { no: 2, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LinkedAccountForPayment {
    return new LinkedAccountForPayment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LinkedAccountForPayment {
    return new LinkedAccountForPayment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LinkedAccountForPayment {
    return new LinkedAccountForPayment().fromJsonString(jsonString, options);
  }

  static equals(a: LinkedAccountForPayment | PlainMessage<LinkedAccountForPayment> | undefined, b: LinkedAccountForPayment | PlainMessage<LinkedAccountForPayment> | undefined): boolean {
    return proto3.util.equals(LinkedAccountForPayment, a, b);
  }
}

/**
 * @generated from message backend.v1.GetXagoDepositDetailsRequest
 */
export class GetXagoDepositDetailsRequest extends Message<GetXagoDepositDetailsRequest> {
  /**
   * @generated from field: string linkedAccount = 1;
   */
  linkedAccount = "";

  constructor(data?: PartialMessage<GetXagoDepositDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetXagoDepositDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "linkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetXagoDepositDetailsRequest {
    return new GetXagoDepositDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetXagoDepositDetailsRequest {
    return new GetXagoDepositDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetXagoDepositDetailsRequest {
    return new GetXagoDepositDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetXagoDepositDetailsRequest | PlainMessage<GetXagoDepositDetailsRequest> | undefined, b: GetXagoDepositDetailsRequest | PlainMessage<GetXagoDepositDetailsRequest> | undefined): boolean {
    return proto3.util.equals(GetXagoDepositDetailsRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetXagoDepositDetailsResponse
 */
export class GetXagoDepositDetailsResponse extends Message<GetXagoDepositDetailsResponse> {
  /**
   * @generated from field: repeated backend.v1.XagoDepositDetails details = 1;
   */
  details: XagoDepositDetails[] = [];

  constructor(data?: PartialMessage<GetXagoDepositDetailsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetXagoDepositDetailsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "details", kind: "message", T: XagoDepositDetails, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetXagoDepositDetailsResponse {
    return new GetXagoDepositDetailsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetXagoDepositDetailsResponse {
    return new GetXagoDepositDetailsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetXagoDepositDetailsResponse {
    return new GetXagoDepositDetailsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetXagoDepositDetailsResponse | PlainMessage<GetXagoDepositDetailsResponse> | undefined, b: GetXagoDepositDetailsResponse | PlainMessage<GetXagoDepositDetailsResponse> | undefined): boolean {
    return proto3.util.equals(GetXagoDepositDetailsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.XagoDepositDetails
 */
export class XagoDepositDetails extends Message<XagoDepositDetails> {
  /**
   * @generated from field: string currency = 1;
   */
  currency = "";

  /**
   * @generated from field: string accountNumber = 2;
   */
  accountNumber = "";

  /**
   * @generated from field: string branchCode = 3;
   */
  branchCode = "";

  /**
   * @generated from field: string bankName = 4;
   */
  bankName = "";

  /**
   * @generated from field: string depositReference = 5;
   */
  depositReference = "";

  constructor(data?: PartialMessage<XagoDepositDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.XagoDepositDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "accountNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "branchCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bankName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "depositReference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): XagoDepositDetails {
    return new XagoDepositDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): XagoDepositDetails {
    return new XagoDepositDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): XagoDepositDetails {
    return new XagoDepositDetails().fromJsonString(jsonString, options);
  }

  static equals(a: XagoDepositDetails | PlainMessage<XagoDepositDetails> | undefined, b: XagoDepositDetails | PlainMessage<XagoDepositDetails> | undefined): boolean {
    return proto3.util.equals(XagoDepositDetails, a, b);
  }
}

/**
 * @generated from message backend.v1.GetBalancesResponse
 */
export class GetBalancesResponse extends Message<GetBalancesResponse> {
  /**
   * @generated from field: repeated backend.v1.Balance balances = 1;
   */
  balances: Balance[] = [];

  constructor(data?: PartialMessage<GetBalancesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetBalancesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "balances", kind: "message", T: Balance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBalancesResponse {
    return new GetBalancesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBalancesResponse {
    return new GetBalancesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBalancesResponse {
    return new GetBalancesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBalancesResponse | PlainMessage<GetBalancesResponse> | undefined, b: GetBalancesResponse | PlainMessage<GetBalancesResponse> | undefined): boolean {
    return proto3.util.equals(GetBalancesResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.Balance
 */
export class Balance extends Message<Balance> {
  /**
   * @generated from field: backend.v1.Amount balance = 1;
   */
  balance?: Amount;

  /**
   * @generated from field: string currency = 2;
   */
  currency = "";

  /**
   * @generated from field: string countryCode = 3;
   */
  countryCode = "";

  /**
   * @generated from field: string linkedAccount = 4;
   */
  linkedAccount = "";

  /**
   * @generated from field: string formattedBalance = 5;
   */
  formattedBalance = "";

  constructor(data?: PartialMessage<Balance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Balance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "balance", kind: "message", T: Amount },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "linkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "formattedBalance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Balance {
    return new Balance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Balance {
    return new Balance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Balance {
    return new Balance().fromJsonString(jsonString, options);
  }

  static equals(a: Balance | PlainMessage<Balance> | undefined, b: Balance | PlainMessage<Balance> | undefined): boolean {
    return proto3.util.equals(Balance, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPtiBalancesResponse
 */
export class GetPtiBalancesResponse extends Message<GetPtiBalancesResponse> {
  /**
   * @generated from field: repeated backend.v1.PtiBalance balances = 1;
   */
  balances: PtiBalance[] = [];

  constructor(data?: PartialMessage<GetPtiBalancesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPtiBalancesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "balances", kind: "message", T: PtiBalance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPtiBalancesResponse {
    return new GetPtiBalancesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPtiBalancesResponse {
    return new GetPtiBalancesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPtiBalancesResponse {
    return new GetPtiBalancesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPtiBalancesResponse | PlainMessage<GetPtiBalancesResponse> | undefined, b: GetPtiBalancesResponse | PlainMessage<GetPtiBalancesResponse> | undefined): boolean {
    return proto3.util.equals(GetPtiBalancesResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.PtiBalance
 */
export class PtiBalance extends Message<PtiBalance> {
  /**
   * @generated from field: backend.v1.Amount balance = 1;
   */
  balance?: Amount;

  /**
   * @generated from field: backend.v1.Amount available = 2;
   */
  available?: Amount;

  /**
   * @generated from field: string currency = 3;
   */
  currency = "";

  /**
   * @generated from field: string linkedAccount = 4;
   */
  linkedAccount = "";

  /**
   * @generated from field: string formattedBalance = 5;
   */
  formattedBalance = "";

  /**
   * @generated from field: string formattedAvailableBalance = 6;
   */
  formattedAvailableBalance = "";

  constructor(data?: PartialMessage<PtiBalance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PtiBalance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "balance", kind: "message", T: Amount },
    { no: 2, name: "available", kind: "message", T: Amount },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "linkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "formattedBalance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "formattedAvailableBalance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PtiBalance {
    return new PtiBalance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PtiBalance {
    return new PtiBalance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PtiBalance {
    return new PtiBalance().fromJsonString(jsonString, options);
  }

  static equals(a: PtiBalance | PlainMessage<PtiBalance> | undefined, b: PtiBalance | PlainMessage<PtiBalance> | undefined): boolean {
    return proto3.util.equals(PtiBalance, a, b);
  }
}

/**
 * @generated from message backend.v1.PtiCreateDepositRequest
 */
export class PtiCreateDepositRequest extends Message<PtiCreateDepositRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: optional string ipAddress = 2;
   */
  ipAddress?: string;

  constructor(data?: PartialMessage<PtiCreateDepositRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PtiCreateDepositRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ipAddress", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PtiCreateDepositRequest {
    return new PtiCreateDepositRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PtiCreateDepositRequest {
    return new PtiCreateDepositRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PtiCreateDepositRequest {
    return new PtiCreateDepositRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PtiCreateDepositRequest | PlainMessage<PtiCreateDepositRequest> | undefined, b: PtiCreateDepositRequest | PlainMessage<PtiCreateDepositRequest> | undefined): boolean {
    return proto3.util.equals(PtiCreateDepositRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetXagoBalanceResponse
 */
export class GetXagoBalanceResponse extends Message<GetXagoBalanceResponse> {
  /**
   * @generated from field: repeated backend.v1.XagoBalance balances = 2;
   */
  balances: XagoBalance[] = [];

  constructor(data?: PartialMessage<GetXagoBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetXagoBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "balances", kind: "message", T: XagoBalance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetXagoBalanceResponse {
    return new GetXagoBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetXagoBalanceResponse {
    return new GetXagoBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetXagoBalanceResponse {
    return new GetXagoBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetXagoBalanceResponse | PlainMessage<GetXagoBalanceResponse> | undefined, b: GetXagoBalanceResponse | PlainMessage<GetXagoBalanceResponse> | undefined): boolean {
    return proto3.util.equals(GetXagoBalanceResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.XagoBalance
 */
export class XagoBalance extends Message<XagoBalance> {
  /**
   * @generated from field: backend.v1.Amount balance = 1;
   */
  balance?: Amount;

  /**
   * @generated from field: backend.v1.Amount available = 2;
   */
  available?: Amount;

  /**
   * @generated from field: string currency = 3;
   */
  currency = "";

  /**
   * @generated from field: string linkedAccount = 4;
   */
  linkedAccount = "";

  /**
   * @generated from field: string formattedBalance = 5;
   */
  formattedBalance = "";

  /**
   * @generated from field: string formattedAvailableBalance = 6;
   */
  formattedAvailableBalance = "";

  constructor(data?: PartialMessage<XagoBalance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.XagoBalance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "balance", kind: "message", T: Amount },
    { no: 2, name: "available", kind: "message", T: Amount },
    { no: 3, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "linkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "formattedBalance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "formattedAvailableBalance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): XagoBalance {
    return new XagoBalance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): XagoBalance {
    return new XagoBalance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): XagoBalance {
    return new XagoBalance().fromJsonString(jsonString, options);
  }

  static equals(a: XagoBalance | PlainMessage<XagoBalance> | undefined, b: XagoBalance | PlainMessage<XagoBalance> | undefined): boolean {
    return proto3.util.equals(XagoBalance, a, b);
  }
}

/**
 * @generated from message backend.v1.WithdrawXagoBalanceRequest
 */
export class WithdrawXagoBalanceRequest extends Message<WithdrawXagoBalanceRequest> {
  /**
   * @generated from field: string fromLinkedAccount = 1;
   */
  fromLinkedAccount = "";

  /**
   * @generated from field: string toLinkedAccount = 2;
   */
  toLinkedAccount = "";

  /**
   * @generated from field: backend.v1.Amount amount = 3;
   */
  amount?: Amount;

  /**
   * @generated from field: string note = 4;
   */
  note = "";

  constructor(data?: PartialMessage<WithdrawXagoBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.WithdrawXagoBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fromLinkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "toLinkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Amount },
    { no: 4, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WithdrawXagoBalanceRequest {
    return new WithdrawXagoBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WithdrawXagoBalanceRequest {
    return new WithdrawXagoBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WithdrawXagoBalanceRequest {
    return new WithdrawXagoBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WithdrawXagoBalanceRequest | PlainMessage<WithdrawXagoBalanceRequest> | undefined, b: WithdrawXagoBalanceRequest | PlainMessage<WithdrawXagoBalanceRequest> | undefined): boolean {
    return proto3.util.equals(WithdrawXagoBalanceRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.AddXagoBalanceAccountRequest
 */
export class AddXagoBalanceAccountRequest extends Message<AddXagoBalanceAccountRequest> {
  /**
   * e.g. USD or ZAR
   *
   * @generated from field: string currencyCode = 1;
   */
  currencyCode = "";

  /**
   * @generated from field: string nickname = 2;
   */
  nickname = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  constructor(data?: PartialMessage<AddXagoBalanceAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.AddXagoBalanceAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "currencyCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nickname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddXagoBalanceAccountRequest {
    return new AddXagoBalanceAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddXagoBalanceAccountRequest {
    return new AddXagoBalanceAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddXagoBalanceAccountRequest {
    return new AddXagoBalanceAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddXagoBalanceAccountRequest | PlainMessage<AddXagoBalanceAccountRequest> | undefined, b: AddXagoBalanceAccountRequest | PlainMessage<AddXagoBalanceAccountRequest> | undefined): boolean {
    return proto3.util.equals(AddXagoBalanceAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.AddXagoBankAccountRequest
 */
export class AddXagoBankAccountRequest extends Message<AddXagoBankAccountRequest> {
  /**
   * @generated from field: string accountNumber = 1;
   */
  accountNumber = "";

  /**
   * @generated from field: string branchCode = 2;
   */
  branchCode = "";

  /**
   * @generated from field: string bankName = 3;
   */
  bankName = "";

  /**
   * @generated from field: string iban = 4;
   */
  iban = "";

  /**
   * @generated from field: string bic = 5;
   */
  bic = "";

  constructor(data?: PartialMessage<AddXagoBankAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.AddXagoBankAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "accountNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branchCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bankName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "iban", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "bic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddXagoBankAccountRequest {
    return new AddXagoBankAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddXagoBankAccountRequest {
    return new AddXagoBankAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddXagoBankAccountRequest {
    return new AddXagoBankAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddXagoBankAccountRequest | PlainMessage<AddXagoBankAccountRequest> | undefined, b: AddXagoBankAccountRequest | PlainMessage<AddXagoBankAccountRequest> | undefined): boolean {
    return proto3.util.equals(AddXagoBankAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetDefaultSendLinkedAccountRequest
 */
export class SetDefaultSendLinkedAccountRequest extends Message<SetDefaultSendLinkedAccountRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SetDefaultSendLinkedAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetDefaultSendLinkedAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetDefaultSendLinkedAccountRequest {
    return new SetDefaultSendLinkedAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetDefaultSendLinkedAccountRequest {
    return new SetDefaultSendLinkedAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetDefaultSendLinkedAccountRequest {
    return new SetDefaultSendLinkedAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetDefaultSendLinkedAccountRequest | PlainMessage<SetDefaultSendLinkedAccountRequest> | undefined, b: SetDefaultSendLinkedAccountRequest | PlainMessage<SetDefaultSendLinkedAccountRequest> | undefined): boolean {
    return proto3.util.equals(SetDefaultSendLinkedAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetDefaultReceiveLinkedAccountRequest
 */
export class SetDefaultReceiveLinkedAccountRequest extends Message<SetDefaultReceiveLinkedAccountRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SetDefaultReceiveLinkedAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetDefaultReceiveLinkedAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetDefaultReceiveLinkedAccountRequest {
    return new SetDefaultReceiveLinkedAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetDefaultReceiveLinkedAccountRequest {
    return new SetDefaultReceiveLinkedAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetDefaultReceiveLinkedAccountRequest {
    return new SetDefaultReceiveLinkedAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetDefaultReceiveLinkedAccountRequest | PlainMessage<SetDefaultReceiveLinkedAccountRequest> | undefined, b: SetDefaultReceiveLinkedAccountRequest | PlainMessage<SetDefaultReceiveLinkedAccountRequest> | undefined): boolean {
    return proto3.util.equals(SetDefaultReceiveLinkedAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SlackCallbackRequest
 */
export class SlackCallbackRequest extends Message<SlackCallbackRequest> {
  /**
   * @generated from field: string state = 1;
   */
  state = "";

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  constructor(data?: PartialMessage<SlackCallbackRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SlackCallbackRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SlackCallbackRequest {
    return new SlackCallbackRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SlackCallbackRequest {
    return new SlackCallbackRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SlackCallbackRequest {
    return new SlackCallbackRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SlackCallbackRequest | PlainMessage<SlackCallbackRequest> | undefined, b: SlackCallbackRequest | PlainMessage<SlackCallbackRequest> | undefined): boolean {
    return proto3.util.equals(SlackCallbackRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SlackCallbackResponse
 */
export class SlackCallbackResponse extends Message<SlackCallbackResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SlackCallbackResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SlackCallbackResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SlackCallbackResponse {
    return new SlackCallbackResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SlackCallbackResponse {
    return new SlackCallbackResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SlackCallbackResponse {
    return new SlackCallbackResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SlackCallbackResponse | PlainMessage<SlackCallbackResponse> | undefined, b: SlackCallbackResponse | PlainMessage<SlackCallbackResponse> | undefined): boolean {
    return proto3.util.equals(SlackCallbackResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateSlackAuthURLResponse
 */
export class CreateSlackAuthURLResponse extends Message<CreateSlackAuthURLResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<CreateSlackAuthURLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateSlackAuthURLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSlackAuthURLResponse {
    return new CreateSlackAuthURLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSlackAuthURLResponse {
    return new CreateSlackAuthURLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSlackAuthURLResponse {
    return new CreateSlackAuthURLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSlackAuthURLResponse | PlainMessage<CreateSlackAuthURLResponse> | undefined, b: CreateSlackAuthURLResponse | PlainMessage<CreateSlackAuthURLResponse> | undefined): boolean {
    return proto3.util.equals(CreateSlackAuthURLResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.Amount
 */
export class Amount extends Message<Amount> {
  /**
   * @generated from field: uint64 amount = 1;
   */
  amount = protoInt64.zero;

  /**
   * @generated from field: string asset = 2;
   */
  asset = "";

  /**
   * @generated from field: int32 assetScale = 3;
   */
  assetScale = 0;

  /**
   * @generated from field: string country = 4;
   */
  country = "";

  constructor(data?: PartialMessage<Amount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Amount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "amount", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "assetScale", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Amount {
    return new Amount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Amount {
    return new Amount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Amount {
    return new Amount().fromJsonString(jsonString, options);
  }

  static equals(a: Amount | PlainMessage<Amount> | undefined, b: Amount | PlainMessage<Amount> | undefined): boolean {
    return proto3.util.equals(Amount, a, b);
  }
}

/**
 * @generated from message backend.v1.CardTransactionDetails
 */
export class CardTransactionDetails extends Message<CardTransactionDetails> {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId = "";

  /**
   * @generated from field: string card_masked_pan = 2;
   */
  cardMaskedPan = "";

  /**
   * @generated from field: int64 type = 3;
   */
  type = protoInt64.zero;

  constructor(data?: PartialMessage<CardTransactionDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CardTransactionDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "card_masked_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CardTransactionDetails {
    return new CardTransactionDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CardTransactionDetails {
    return new CardTransactionDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CardTransactionDetails {
    return new CardTransactionDetails().fromJsonString(jsonString, options);
  }

  static equals(a: CardTransactionDetails | PlainMessage<CardTransactionDetails> | undefined, b: CardTransactionDetails | PlainMessage<CardTransactionDetails> | undefined): boolean {
    return proto3.util.equals(CardTransactionDetails, a, b);
  }
}

/**
 * @generated from message backend.v1.Transaction
 */
export class Transaction extends Message<Transaction> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: backend.v1.Amount amount = 3;
   */
  amount?: Amount;

  /**
   * @generated from field: string source = 4;
   */
  source = "";

  /**
   * @generated from field: string destination = 5;
   */
  destination = "";

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 6;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: string state = 7;
   */
  state = "";

  /**
   * @generated from field: string foreignId = 9;
   */
  foreignId = "";

  /**
   * @generated from field: string receiverAccountId = 10;
   */
  receiverAccountId = "";

  /**
   * @generated from field: string senderAccountId = 11;
   */
  senderAccountId = "";

  /**
   * Display
   *
   * @generated from field: string title = 12;
   */
  title = "";

  /**
   * @generated from field: string formattedAmount = 13;
   */
  formattedAmount = "";

  /**
   * @generated from field: string formattedTime = 14;
   */
  formattedTime = "";

  /**
   * @generated from field: string formattedDate = 15;
   */
  formattedDate = "";

  /**
   * @generated from field: string subtotal = 16;
   */
  subtotal = "";

  /**
   * @generated from field: string fees = 17;
   */
  fees = "";

  /**
   * @generated from field: string accountTitle = 18;
   */
  accountTitle = "";

  /**
   * @generated from field: string reference = 19;
   */
  reference = "";

  /**
   * @generated from field: string destinationIdentity = 20;
   */
  destinationIdentity = "";

  /**
   * @generated from field: string destinationIdentityType = 21;
   */
  destinationIdentityType = "";

  /**
   * NA , PENDING , COMPLETE
   *
   * @generated from field: int32 refundState = 22;
   */
  refundState = 0;

  /**
   * @generated from field: string fundsReceived = 23;
   */
  fundsReceived = "";

  /**
   * @generated from field: optional backend.v1.CardTransactionDetails cardTransactionDetails = 24;
   */
  cardTransactionDetails?: CardTransactionDetails;

  constructor(data?: PartialMessage<Transaction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Transaction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Amount },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "destination", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "timestamp", kind: "message", T: Timestamp },
    { no: 7, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "foreignId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "receiverAccountId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "senderAccountId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "formattedAmount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "formattedTime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "formattedDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "subtotal", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "fees", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "accountTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "destinationIdentity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "destinationIdentityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "refundState", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "fundsReceived", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "cardTransactionDetails", kind: "message", T: CardTransactionDetails, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Transaction {
    return new Transaction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Transaction {
    return new Transaction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Transaction {
    return new Transaction().fromJsonString(jsonString, options);
  }

  static equals(a: Transaction | PlainMessage<Transaction> | undefined, b: Transaction | PlainMessage<Transaction> | undefined): boolean {
    return proto3.util.equals(Transaction, a, b);
  }
}

/**
 * @generated from message backend.v1.ListTransactionsResponse
 */
export class ListTransactionsResponse extends Message<ListTransactionsResponse> {
  /**
   * @generated from field: repeated backend.v1.Transaction transactions = 1;
   */
  transactions: Transaction[] = [];

  /**
   * @generated from field: string nextPageToken = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListTransactionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListTransactionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transactions", kind: "message", T: Transaction, repeated: true },
    { no: 2, name: "nextPageToken", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTransactionsResponse {
    return new ListTransactionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTransactionsResponse {
    return new ListTransactionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTransactionsResponse {
    return new ListTransactionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListTransactionsResponse | PlainMessage<ListTransactionsResponse> | undefined, b: ListTransactionsResponse | PlainMessage<ListTransactionsResponse> | undefined): boolean {
    return proto3.util.equals(ListTransactionsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.ConfirmPaymentRequest
 */
export class ConfirmPaymentRequest extends Message<ConfirmPaymentRequest> {
  /**
   * id or publicID
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ConfirmPaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ConfirmPaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmPaymentRequest {
    return new ConfirmPaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmPaymentRequest {
    return new ConfirmPaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmPaymentRequest {
    return new ConfirmPaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmPaymentRequest | PlainMessage<ConfirmPaymentRequest> | undefined, b: ConfirmPaymentRequest | PlainMessage<ConfirmPaymentRequest> | undefined): boolean {
    return proto3.util.equals(ConfirmPaymentRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPaymentRequest
 */
export class GetPaymentRequest extends Message<GetPaymentRequest> {
  /**
   * id or publicID
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetPaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentRequest {
    return new GetPaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentRequest {
    return new GetPaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentRequest {
    return new GetPaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentRequest | PlainMessage<GetPaymentRequest> | undefined, b: GetPaymentRequest | PlainMessage<GetPaymentRequest> | undefined): boolean {
    return proto3.util.equals(GetPaymentRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.UpdatePaymentRequest
 */
export class UpdatePaymentRequest extends Message<UpdatePaymentRequest> {
  /**
   * id or publicID
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: optional backend.v1.Amount senderAmount = 2;
   */
  senderAmount?: Amount;

  /**
   * @generated from field: optional backend.v1.Amount receiverAmount = 3;
   */
  receiverAmount?: Amount;

  /**
   * @generated from field: optional string note = 4;
   */
  note?: string;

  /**
   * Linked Account ID
   *
   * @generated from field: optional string senderAccount = 5;
   */
  senderAccount?: string;

  /**
   * Linked Account ID
   *
   * @generated from field: optional string receiverAccount = 6;
   */
  receiverAccount?: string;

  /**
   * @generated from field: optional string receiverIdentity = 7;
   */
  receiverIdentity?: string;

  /**
   * 1 - Twitter, 2 - WalletID, 3 - WalletURL
   *
   * @generated from field: optional int32 receiverIdentityType = 8;
   */
  receiverIdentityType?: number;

  /**
   * @generated from field: optional string threeDSID = 9;
   */
  threeDSID?: string;

  /**
   * @generated from field: optional string ipAddress = 10;
   */
  ipAddress?: string;

  constructor(data?: PartialMessage<UpdatePaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.UpdatePaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "senderAmount", kind: "message", T: Amount, opt: true },
    { no: 3, name: "receiverAmount", kind: "message", T: Amount, opt: true },
    { no: 4, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "senderAccount", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "receiverAccount", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "receiverIdentity", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "receiverIdentityType", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 9, name: "threeDSID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "ipAddress", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePaymentRequest {
    return new UpdatePaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePaymentRequest {
    return new UpdatePaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePaymentRequest {
    return new UpdatePaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePaymentRequest | PlainMessage<UpdatePaymentRequest> | undefined, b: UpdatePaymentRequest | PlainMessage<UpdatePaymentRequest> | undefined): boolean {
    return proto3.util.equals(UpdatePaymentRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Payment
 */
export class Payment extends Message<Payment> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string publicID = 2;
   */
  publicID = "";

  /**
   * 1 - Created, 2 - Confirmed, 3 - Processing, 4 - Completed, 5 - Failed
   *
   * @generated from field: int32 state = 3;
   */
  state = 0;

  /**
   * @generated from field: string receiverWalletUrl = 4;
   */
  receiverWalletUrl = "";

  /**
   * @generated from field: string receiverIdentity = 5;
   */
  receiverIdentity = "";

  /**
   * 1 - Twitter, 2 - WalletID, 3 - WalletURL
   *
   * @generated from field: int32 receiverIdentityType = 6;
   */
  receiverIdentityType = 0;

  /**
   * @generated from field: backend.v1.Amount senderAmount = 7;
   */
  senderAmount?: Amount;

  /**
   * Linked Account ID
   *
   * @generated from field: string senderAccount = 8;
   */
  senderAccount = "";

  /**
   * @generated from field: string note = 9;
   */
  note = "";

  /**
   * 1 - ThreeDS
   *
   * @generated from field: repeated int32 requiredActions = 10;
   */
  requiredActions: number[] = [];

  /**
   * @generated from field: string fxRate = 11;
   */
  fxRate = "";

  /**
   * @generated from field: backend.v1.Amount receiverAmount = 12;
   */
  receiverAmount?: Amount;

  /**
   * total debit amount
   *
   * @generated from field: string totalSendAmount = 13;
   */
  totalSendAmount = "";

  /**
   * @generated from field: string receiverLinkedAccountCountryCode = 14;
   */
  receiverLinkedAccountCountryCode = "";

  /**
   * @generated from field: string formattedFees = 15;
   */
  formattedFees = "";

  /**
   * Linked account ID. Only populated on withdrawals
   *
   * @generated from field: string receiverAccount = 16;
   */
  receiverAccount = "";

  constructor(data?: PartialMessage<Payment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Payment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "publicID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "receiverWalletUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "receiverIdentity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "receiverIdentityType", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "senderAmount", kind: "message", T: Amount },
    { no: 8, name: "senderAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "requiredActions", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 11, name: "fxRate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "receiverAmount", kind: "message", T: Amount },
    { no: 13, name: "totalSendAmount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "receiverLinkedAccountCountryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "formattedFees", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "receiverAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Payment {
    return new Payment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Payment {
    return new Payment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Payment {
    return new Payment().fromJsonString(jsonString, options);
  }

  static equals(a: Payment | PlainMessage<Payment> | undefined, b: Payment | PlainMessage<Payment> | undefined): boolean {
    return proto3.util.equals(Payment, a, b);
  }
}

/**
 * @generated from message backend.v1.CreatePaymentRequest
 */
export class CreatePaymentRequest extends Message<CreatePaymentRequest> {
  /**
   * @generated from field: backend.v1.Amount senderAmount = 1;
   */
  senderAmount?: Amount;

  /**
   * @generated from field: backend.v1.Amount receiverAmount = 2;
   */
  receiverAmount?: Amount;

  /**
   * @generated from field: string receiverIdentity = 3;
   */
  receiverIdentity = "";

  /**
   * 1 - Twitter, 2 - WalletID, 3 - WalletURL
   *
   * @generated from field: int32 receiverIdentityType = 4;
   */
  receiverIdentityType = 0;

  /**
   * Linked Account ID
   *
   * @generated from field: optional string senderAccount = 5;
   */
  senderAccount?: string;

  /**
   * Linked Account ID
   *
   * @generated from field: optional string receiverAccount = 6;
   */
  receiverAccount?: string;

  /**
   * @generated from field: optional string note = 7;
   */
  note?: string;

  /**
   * @generated from field: optional string ipAddress = 8;
   */
  ipAddress?: string;

  constructor(data?: PartialMessage<CreatePaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreatePaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "senderAmount", kind: "message", T: Amount },
    { no: 2, name: "receiverAmount", kind: "message", T: Amount },
    { no: 3, name: "receiverIdentity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "receiverIdentityType", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "senderAccount", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "receiverAccount", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "ipAddress", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePaymentRequest {
    return new CreatePaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePaymentRequest {
    return new CreatePaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePaymentRequest {
    return new CreatePaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePaymentRequest | PlainMessage<CreatePaymentRequest> | undefined, b: CreatePaymentRequest | PlainMessage<CreatePaymentRequest> | undefined): boolean {
    return proto3.util.equals(CreatePaymentRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.TransferBalanceRequest
 */
export class TransferBalanceRequest extends Message<TransferBalanceRequest> {
  /**
   * @generated from field: string fromLinkedAccount = 1;
   */
  fromLinkedAccount = "";

  /**
   * @generated from field: string toLinkedAccount = 2;
   */
  toLinkedAccount = "";

  /**
   * @generated from field: backend.v1.Amount amount = 3;
   */
  amount?: Amount;

  /**
   * @generated from field: string note = 4;
   */
  note = "";

  constructor(data?: PartialMessage<TransferBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.TransferBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fromLinkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "toLinkedAccount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amount", kind: "message", T: Amount },
    { no: 4, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferBalanceRequest {
    return new TransferBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferBalanceRequest {
    return new TransferBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferBalanceRequest {
    return new TransferBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TransferBalanceRequest | PlainMessage<TransferBalanceRequest> | undefined, b: TransferBalanceRequest | PlainMessage<TransferBalanceRequest> | undefined): boolean {
    return proto3.util.equals(TransferBalanceRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetCardDetailsRequest
 */
export class GetCardDetailsRequest extends Message<GetCardDetailsRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetCardDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetCardDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCardDetailsRequest {
    return new GetCardDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCardDetailsRequest {
    return new GetCardDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCardDetailsRequest {
    return new GetCardDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCardDetailsRequest | PlainMessage<GetCardDetailsRequest> | undefined, b: GetCardDetailsRequest | PlainMessage<GetCardDetailsRequest> | undefined): boolean {
    return proto3.util.equals(GetCardDetailsRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CardDetails
 */
export class CardDetails extends Message<CardDetails> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string network = 2;
   */
  network = "";

  /**
   * @generated from field: string bin = 3;
   */
  bin = "";

  /**
   * @generated from field: string last4 = 4;
   */
  last4 = "";

  /**
   * @generated from field: string type = 5;
   */
  type = "";

  /**
   * @generated from field: string expiration = 6;
   */
  expiration = "";

  /**
   * @generated from field: string nickname = 7;
   */
  nickname = "";

  /**
   * @generated from field: string state = 8;
   */
  state = "";

  /**
   * @generated from field: bool canSend = 9;
   */
  canSend = false;

  /**
   * @generated from field: bool canReceive = 10;
   */
  canReceive = false;

  constructor(data?: PartialMessage<CardDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CardDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "network", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "expiration", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "nickname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "canSend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "canReceive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CardDetails {
    return new CardDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CardDetails {
    return new CardDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CardDetails {
    return new CardDetails().fromJsonString(jsonString, options);
  }

  static equals(a: CardDetails | PlainMessage<CardDetails> | undefined, b: CardDetails | PlainMessage<CardDetails> | undefined): boolean {
    return proto3.util.equals(CardDetails, a, b);
  }
}

/**
 * @generated from message backend.v1.SearchWalletsRequest
 */
export class SearchWalletsRequest extends Message<SearchWalletsRequest> {
  /**
   * @generated from field: string term = 1;
   */
  term = "";

  constructor(data?: PartialMessage<SearchWalletsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SearchWalletsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchWalletsRequest {
    return new SearchWalletsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchWalletsRequest {
    return new SearchWalletsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchWalletsRequest {
    return new SearchWalletsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchWalletsRequest | PlainMessage<SearchWalletsRequest> | undefined, b: SearchWalletsRequest | PlainMessage<SearchWalletsRequest> | undefined): boolean {
    return proto3.util.equals(SearchWalletsRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SearchWalletsResponse
 */
export class SearchWalletsResponse extends Message<SearchWalletsResponse> {
  /**
   * @generated from field: repeated backend.v1.SearchResult results = 1;
   */
  results: SearchResult[] = [];

  constructor(data?: PartialMessage<SearchWalletsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SearchWalletsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: SearchResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchWalletsResponse {
    return new SearchWalletsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchWalletsResponse {
    return new SearchWalletsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchWalletsResponse {
    return new SearchWalletsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchWalletsResponse | PlainMessage<SearchWalletsResponse> | undefined, b: SearchWalletsResponse | PlainMessage<SearchWalletsResponse> | undefined): boolean {
    return proto3.util.equals(SearchWalletsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.SearchResult
 */
export class SearchResult extends Message<SearchResult> {
  /**
   * @generated from field: string walletID = 1;
   */
  walletID = "";

  /**
   * @generated from field: string walletUrl = 5;
   */
  walletUrl = "";

  /**
   * @generated from field: bool canSend = 4 [deprecated = true];
   * @deprecated
   */
  canSend = false;

  /**
   * @generated from field: string identifier = 2;
   */
  identifier = "";

  /**
   * @generated from field: string identifierType = 3;
   */
  identifierType = "";

  /**
   * @generated from field: repeated backend.v1.SearchResult subResults = 6;
   */
  subResults: SearchResult[] = [];

  constructor(data?: PartialMessage<SearchResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SearchResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "walletID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "walletUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "canSend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "identifierType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "subResults", kind: "message", T: SearchResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchResult {
    return new SearchResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchResult {
    return new SearchResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchResult {
    return new SearchResult().fromJsonString(jsonString, options);
  }

  static equals(a: SearchResult | PlainMessage<SearchResult> | undefined, b: SearchResult | PlainMessage<SearchResult> | undefined): boolean {
    return proto3.util.equals(SearchResult, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPublicWalletInfoRequest
 */
export class GetPublicWalletInfoRequest extends Message<GetPublicWalletInfoRequest> {
  /**
   * @generated from field: string walletAddress = 1;
   */
  walletAddress = "";

  constructor(data?: PartialMessage<GetPublicWalletInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPublicWalletInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "walletAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPublicWalletInfoRequest {
    return new GetPublicWalletInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPublicWalletInfoRequest {
    return new GetPublicWalletInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPublicWalletInfoRequest {
    return new GetPublicWalletInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPublicWalletInfoRequest | PlainMessage<GetPublicWalletInfoRequest> | undefined, b: GetPublicWalletInfoRequest | PlainMessage<GetPublicWalletInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetPublicWalletInfoRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.PublicWalletInfo
 */
export class PublicWalletInfo extends Message<PublicWalletInfo> {
  /**
   * @generated from field: string walletID = 1;
   */
  walletID = "";

  /**
   * @generated from field: string address = 2;
   */
  address = "";

  /**
   * @generated from field: string shortAddress = 3;
   */
  shortAddress = "";

  /**
   * @generated from field: string publicName = 4;
   */
  publicName = "";

  /**
   * @generated from field: repeated backend.v1.Identity identities = 5;
   */
  identities: Identity[] = [];

  /**
   * @generated from field: bool canReceive = 6;
   */
  canReceive = false;

  constructor(data?: PartialMessage<PublicWalletInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.PublicWalletInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "walletID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shortAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "publicName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "identities", kind: "message", T: Identity, repeated: true },
    { no: 6, name: "canReceive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublicWalletInfo {
    return new PublicWalletInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublicWalletInfo {
    return new PublicWalletInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublicWalletInfo {
    return new PublicWalletInfo().fromJsonString(jsonString, options);
  }

  static equals(a: PublicWalletInfo | PlainMessage<PublicWalletInfo> | undefined, b: PublicWalletInfo | PlainMessage<PublicWalletInfo> | undefined): boolean {
    return proto3.util.equals(PublicWalletInfo, a, b);
  }
}

/**
 * @generated from message backend.v1.WalletInfo
 */
export class WalletInfo extends Message<WalletInfo> {
  /**
   * @generated from field: string walletID = 1;
   */
  walletID = "";

  /**
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * @generated from field: string formattedURL = 3;
   */
  formattedURL = "";

  /**
   * @generated from field: bool hasCard = 4;
   */
  hasCard = false;

  /**
   * @generated from field: bool hasBank = 5;
   */
  hasBank = false;

  /**
   * @generated from field: bool hasIdentities = 6;
   */
  hasIdentities = false;

  /**
   * @generated from field: bool hasTransacted = 7;
   */
  hasTransacted = false;

  /**
   * @generated from field: bool hasWalletAddress = 8;
   */
  hasWalletAddress = false;

  /**
   * @generated from field: bool hasBalances = 9;
   */
  hasBalances = false;

  /**
   * @generated from field: bool exceededLimits = 10;
   */
  exceededLimits = false;

  /**
   * @generated from field: string country = 11;
   */
  country = "";

  constructor(data?: PartialMessage<WalletInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.WalletInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "walletID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "formattedURL", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hasCard", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "hasBank", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "hasIdentities", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "hasTransacted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "hasWalletAddress", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "hasBalances", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "exceededLimits", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WalletInfo {
    return new WalletInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WalletInfo {
    return new WalletInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WalletInfo {
    return new WalletInfo().fromJsonString(jsonString, options);
  }

  static equals(a: WalletInfo | PlainMessage<WalletInfo> | undefined, b: WalletInfo | PlainMessage<WalletInfo> | undefined): boolean {
    return proto3.util.equals(WalletInfo, a, b);
  }
}

/**
 * @generated from message backend.v1.Features
 */
export class Features extends Message<Features> {
  /**
   * @generated from field: bool sendEnabled = 1;
   */
  sendEnabled = false;

  /**
   * @generated from field: bool receiveEnabled = 2;
   */
  receiveEnabled = false;

  /**
   * @generated from field: bool linkedAccountsEnabled = 3;
   */
  linkedAccountsEnabled = false;

  /**
   * @generated from field: bool cardsEnabled = 4;
   */
  cardsEnabled = false;

  /**
   * @generated from field: bool banksEnabled = 5;
   */
  banksEnabled = false;

  /**
   * @generated from field: bool identitiesEnabled = 6;
   */
  identitiesEnabled = false;

  /**
   * @generated from field: bool twitterEnabled = 7;
   */
  twitterEnabled = false;

  /**
   * @generated from field: bool addCardsEnabled = 8;
   */
  addCardsEnabled = false;

  /**
   * @generated from field: bool interacEnabled = 9;
   */
  interacEnabled = false;

  /**
   * @generated from field: bool zarBalanceEnabled = 10;
   */
  zarBalanceEnabled = false;

  /**
   * @generated from field: bool manageWalletCardsEnabled = 11;
   */
  manageWalletCardsEnabled = false;

  /**
   * @generated from field: bool accountEnabled = 12;
   */
  accountEnabled = false;

  constructor(data?: PartialMessage<Features>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Features";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sendEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "receiveEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "linkedAccountsEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "cardsEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "banksEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "identitiesEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "twitterEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "addCardsEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "interacEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "zarBalanceEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "manageWalletCardsEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "accountEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Features {
    return new Features().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Features {
    return new Features().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Features {
    return new Features().fromJsonString(jsonString, options);
  }

  static equals(a: Features | PlainMessage<Features> | undefined, b: Features | PlainMessage<Features> | undefined): boolean {
    return proto3.util.equals(Features, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateCardRequest
 */
export class CreateCardRequest extends Message<CreateCardRequest> {
  /**
   * @generated from field: string tokenID = 1;
   */
  tokenID = "";

  constructor(data?: PartialMessage<CreateCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tokenID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCardRequest {
    return new CreateCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCardRequest {
    return new CreateCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCardRequest {
    return new CreateCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCardRequest | PlainMessage<CreateCardRequest> | undefined, b: CreateCardRequest | PlainMessage<CreateCardRequest> | undefined): boolean {
    return proto3.util.equals(CreateCardRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.InitQuote3DSRequest
 */
export class InitQuote3DSRequest extends Message<InitQuote3DSRequest> {
  /**
   * @generated from field: string quoteID = 1;
   */
  quoteID = "";

  constructor(data?: PartialMessage<InitQuote3DSRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.InitQuote3DSRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "quoteID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitQuote3DSRequest {
    return new InitQuote3DSRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitQuote3DSRequest {
    return new InitQuote3DSRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitQuote3DSRequest {
    return new InitQuote3DSRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitQuote3DSRequest | PlainMessage<InitQuote3DSRequest> | undefined, b: InitQuote3DSRequest | PlainMessage<InitQuote3DSRequest> | undefined): boolean {
    return proto3.util.equals(InitQuote3DSRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Connection
 */
export class Connection extends Message<Connection> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string applicationName = 2;
   */
  applicationName = "";

  /**
   * @generated from field: string publicKeyFingerprint = 3;
   */
  publicKeyFingerprint = "";

  /**
   * @generated from field: string createdAt = 4;
   */
  createdAt = "";

  /**
   * @generated from field: string lastUsedAt = 5;
   */
  lastUsedAt = "";

  constructor(data?: PartialMessage<Connection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Connection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "applicationName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "publicKeyFingerprint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "createdAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "lastUsedAt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Connection {
    return new Connection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Connection {
    return new Connection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Connection {
    return new Connection().fromJsonString(jsonString, options);
  }

  static equals(a: Connection | PlainMessage<Connection> | undefined, b: Connection | PlainMessage<Connection> | undefined): boolean {
    return proto3.util.equals(Connection, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateConnectionRequest
 */
export class CreateConnectionRequest extends Message<CreateConnectionRequest> {
  /**
   * @generated from field: string applicationName = 1;
   */
  applicationName = "";

  /**
   * pem encoded ed25519 public key
   *
   * @generated from field: string publicKey = 2;
   */
  publicKey = "";

  constructor(data?: PartialMessage<CreateConnectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateConnectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "applicationName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "publicKey", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateConnectionRequest {
    return new CreateConnectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateConnectionRequest {
    return new CreateConnectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateConnectionRequest {
    return new CreateConnectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateConnectionRequest | PlainMessage<CreateConnectionRequest> | undefined, b: CreateConnectionRequest | PlainMessage<CreateConnectionRequest> | undefined): boolean {
    return proto3.util.equals(CreateConnectionRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetConnectionRequest
 */
export class GetConnectionRequest extends Message<GetConnectionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetConnectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetConnectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConnectionRequest {
    return new GetConnectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConnectionRequest {
    return new GetConnectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConnectionRequest {
    return new GetConnectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetConnectionRequest | PlainMessage<GetConnectionRequest> | undefined, b: GetConnectionRequest | PlainMessage<GetConnectionRequest> | undefined): boolean {
    return proto3.util.equals(GetConnectionRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.DeleteConnectionRequest
 */
export class DeleteConnectionRequest extends Message<DeleteConnectionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteConnectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.DeleteConnectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteConnectionRequest {
    return new DeleteConnectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteConnectionRequest {
    return new DeleteConnectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteConnectionRequest {
    return new DeleteConnectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteConnectionRequest | PlainMessage<DeleteConnectionRequest> | undefined, b: DeleteConnectionRequest | PlainMessage<DeleteConnectionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteConnectionRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.ListConnectionsResponse
 */
export class ListConnectionsResponse extends Message<ListConnectionsResponse> {
  /**
   * @generated from field: repeated backend.v1.Connection keys = 1;
   */
  keys: Connection[] = [];

  constructor(data?: PartialMessage<ListConnectionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListConnectionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "keys", kind: "message", T: Connection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListConnectionsResponse {
    return new ListConnectionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListConnectionsResponse {
    return new ListConnectionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListConnectionsResponse {
    return new ListConnectionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListConnectionsResponse | PlainMessage<ListConnectionsResponse> | undefined, b: ListConnectionsResponse | PlainMessage<ListConnectionsResponse> | undefined): boolean {
    return proto3.util.equals(ListConnectionsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.Transfer
 */
export class Transfer extends Message<Transfer> {
  /**
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * @generated from field: string state = 2;
   */
  state = "";

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 3;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: backend.v1.Amount amount = 4;
   */
  amount?: Amount;

  /**
   * @generated from field: string foreignId = 5;
   */
  foreignId = "";

  /**
   * @generated from field: string linkedAccountId = 6;
   */
  linkedAccountId = "";

  constructor(data?: PartialMessage<Transfer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Transfer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp", kind: "message", T: Timestamp },
    { no: 4, name: "amount", kind: "message", T: Amount },
    { no: 5, name: "foreignId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "linkedAccountId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Transfer {
    return new Transfer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Transfer {
    return new Transfer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Transfer {
    return new Transfer().fromJsonString(jsonString, options);
  }

  static equals(a: Transfer | PlainMessage<Transfer> | undefined, b: Transfer | PlainMessage<Transfer> | undefined): boolean {
    return proto3.util.equals(Transfer, a, b);
  }
}

/**
 * @generated from message backend.v1.IndividualKYCResponse
 */
export class IndividualKYCResponse extends Message<IndividualKYCResponse> {
  /**
   * @generated from field: string firstName = 1;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 2;
   */
  lastName = "";

  /**
   * @generated from field: string countryCode = 3;
   */
  countryCode = "";

  /**
   * 0 Unknown, 1 Male, 2 Female, 3 Other
   *
   * @generated from field: int32 gender = 4;
   */
  gender = 0;

  /**
   * @generated from field: google.protobuf.Timestamp dateOfBirth = 5;
   */
  dateOfBirth?: Timestamp;

  /**
   * @generated from field: backend.v1.Address address = 6;
   */
  address?: Address;

  /**
   * @generated from field: string placeOfBirth = 7;
   */
  placeOfBirth = "";

  /**
   * @generated from field: string nationality = 8;
   */
  nationality = "";

  constructor(data?: PartialMessage<IndividualKYCResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.IndividualKYCResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "gender", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "dateOfBirth", kind: "message", T: Timestamp },
    { no: 6, name: "address", kind: "message", T: Address },
    { no: 7, name: "placeOfBirth", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "nationality", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndividualKYCResponse {
    return new IndividualKYCResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndividualKYCResponse {
    return new IndividualKYCResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndividualKYCResponse {
    return new IndividualKYCResponse().fromJsonString(jsonString, options);
  }

  static equals(a: IndividualKYCResponse | PlainMessage<IndividualKYCResponse> | undefined, b: IndividualKYCResponse | PlainMessage<IndividualKYCResponse> | undefined): boolean {
    return proto3.util.equals(IndividualKYCResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.UpdateIndividualKYCRequest
 */
export class UpdateIndividualKYCRequest extends Message<UpdateIndividualKYCRequest> {
  /**
   * @generated from field: optional string firstName = 1;
   */
  firstName?: string;

  /**
   * @generated from field: optional string lastName = 2;
   */
  lastName?: string;

  /**
   * @generated from field: optional string countryCode = 3;
   */
  countryCode?: string;

  /**
   * 0 Unknown, 1 Male, 2 Female, 3 Other
   *
   * @generated from field: optional int32 gender = 4;
   */
  gender?: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp dateOfBirth = 5;
   */
  dateOfBirth?: Timestamp;

  /**
   * @generated from field: optional backend.v1.Address address = 6;
   */
  address?: Address;

  /**
   * @generated from field: string ipAddress = 7;
   */
  ipAddress = "";

  /**
   * @generated from field: optional string placeOfBirth = 8;
   */
  placeOfBirth?: string;

  /**
   * @generated from field: optional string nationality = 9;
   */
  nationality?: string;

  constructor(data?: PartialMessage<UpdateIndividualKYCRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.UpdateIndividualKYCRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "gender", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "dateOfBirth", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "address", kind: "message", T: Address, opt: true },
    { no: 7, name: "ipAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "placeOfBirth", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "nationality", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIndividualKYCRequest {
    return new UpdateIndividualKYCRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIndividualKYCRequest {
    return new UpdateIndividualKYCRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIndividualKYCRequest {
    return new UpdateIndividualKYCRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIndividualKYCRequest | PlainMessage<UpdateIndividualKYCRequest> | undefined, b: UpdateIndividualKYCRequest | PlainMessage<UpdateIndividualKYCRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIndividualKYCRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Address
 */
export class Address extends Message<Address> {
  /**
   * @generated from field: optional string line1 = 1;
   */
  line1?: string;

  /**
   * @generated from field: optional string line2 = 2;
   */
  line2?: string;

  /**
   * @generated from field: optional string building = 3;
   */
  building?: string;

  /**
   * @generated from field: optional string apartment = 4;
   */
  apartment?: string;

  /**
   * @generated from field: optional string city = 5;
   */
  city?: string;

  /**
   * @generated from field: optional string state = 6;
   */
  state?: string;

  /**
   * @generated from field: optional string zipCode = 7;
   */
  zipCode?: string;

  /**
   * @generated from field: optional string countryCode = 8;
   */
  countryCode?: string;

  /**
   * @generated from field: optional string placeID = 9;
   */
  placeID?: string;

  /**
   * @generated from field: optional string formattedAddress = 10;
   */
  formattedAddress?: string;

  constructor(data?: PartialMessage<Address>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Address";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "line1", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "line2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "building", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "apartment", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "zipCode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "placeID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "formattedAddress", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Address {
    return new Address().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Address {
    return new Address().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Address {
    return new Address().fromJsonString(jsonString, options);
  }

  static equals(a: Address | PlainMessage<Address> | undefined, b: Address | PlainMessage<Address> | undefined): boolean {
    return proto3.util.equals(Address, a, b);
  }
}

/**
 * @generated from message backend.v1.IsUSPSAddressResponse
 */
export class IsUSPSAddressResponse extends Message<IsUSPSAddressResponse> {
  /**
   * @generated from field: bool valid = 1;
   */
  valid = false;

  constructor(data?: PartialMessage<IsUSPSAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.IsUSPSAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "valid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IsUSPSAddressResponse {
    return new IsUSPSAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IsUSPSAddressResponse {
    return new IsUSPSAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IsUSPSAddressResponse {
    return new IsUSPSAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: IsUSPSAddressResponse | PlainMessage<IsUSPSAddressResponse> | undefined, b: IsUSPSAddressResponse | PlainMessage<IsUSPSAddressResponse> | undefined): boolean {
    return proto3.util.equals(IsUSPSAddressResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetBankAccountWidgetRequest
 */
export class GetBankAccountWidgetRequest extends Message<GetBankAccountWidgetRequest> {
  constructor(data?: PartialMessage<GetBankAccountWidgetRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetBankAccountWidgetRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBankAccountWidgetRequest {
    return new GetBankAccountWidgetRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBankAccountWidgetRequest {
    return new GetBankAccountWidgetRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBankAccountWidgetRequest {
    return new GetBankAccountWidgetRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBankAccountWidgetRequest | PlainMessage<GetBankAccountWidgetRequest> | undefined, b: GetBankAccountWidgetRequest | PlainMessage<GetBankAccountWidgetRequest> | undefined): boolean {
    return proto3.util.equals(GetBankAccountWidgetRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetBankAccountWidgetResponse
 */
export class GetBankAccountWidgetResponse extends Message<GetBankAccountWidgetResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<GetBankAccountWidgetResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetBankAccountWidgetResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBankAccountWidgetResponse {
    return new GetBankAccountWidgetResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBankAccountWidgetResponse {
    return new GetBankAccountWidgetResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBankAccountWidgetResponse {
    return new GetBankAccountWidgetResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBankAccountWidgetResponse | PlainMessage<GetBankAccountWidgetResponse> | undefined, b: GetBankAccountWidgetResponse | PlainMessage<GetBankAccountWidgetResponse> | undefined): boolean {
    return proto3.util.equals(GetBankAccountWidgetResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.AddBankAccountRequest
 */
export class AddBankAccountRequest extends Message<AddBankAccountRequest> {
  /**
   * @generated from field: string userGuid = 1;
   */
  userGuid = "";

  /**
   * @generated from field: string memberGuid = 2;
   */
  memberGuid = "";

  constructor(data?: PartialMessage<AddBankAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.AddBankAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "userGuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "memberGuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddBankAccountRequest {
    return new AddBankAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddBankAccountRequest {
    return new AddBankAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddBankAccountRequest {
    return new AddBankAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddBankAccountRequest | PlainMessage<AddBankAccountRequest> | undefined, b: AddBankAccountRequest | PlainMessage<AddBankAccountRequest> | undefined): boolean {
    return proto3.util.equals(AddBankAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.AddBankAccountResponse
 */
export class AddBankAccountResponse extends Message<AddBankAccountResponse> {
  /**
   * @generated from field: string fundingsourceId = 1;
   */
  fundingsourceId = "";

  constructor(data?: PartialMessage<AddBankAccountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.AddBankAccountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fundingsourceId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddBankAccountResponse {
    return new AddBankAccountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddBankAccountResponse {
    return new AddBankAccountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddBankAccountResponse {
    return new AddBankAccountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AddBankAccountResponse | PlainMessage<AddBankAccountResponse> | undefined, b: AddBankAccountResponse | PlainMessage<AddBankAccountResponse> | undefined): boolean {
    return proto3.util.equals(AddBankAccountResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.LinkedAccount
 */
export class LinkedAccount extends Message<LinkedAccount> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string mask = 4;
   */
  mask = "";

  /**
   * @generated from field: string nickname = 5;
   */
  nickname = "";

  /**
   * Display
   *
   * @generated from field: bool canSend = 6;
   */
  canSend = false;

  /**
   * @generated from field: bool canReceive = 7;
   */
  canReceive = false;

  /**
   * @generated from field: string title = 8;
   */
  title = "";

  /**
   * e.g. USD
   *
   * @generated from field: string sendCurrencyCode = 9;
   */
  sendCurrencyCode = "";

  /**
   * e.g. US
   *
   * @generated from field: string sendCurrencyCountryCode = 10;
   */
  sendCurrencyCountryCode = "";

  /**
   * @generated from field: string receiveCurrencyCode = 11;
   */
  receiveCurrencyCode = "";

  /**
   * @generated from field: string receiveCurrencyCountryCode = 12;
   */
  receiveCurrencyCountryCode = "";

  /**
   * @generated from field: bool defaultSend = 13;
   */
  defaultSend = false;

  /**
   * @generated from field: bool defaultReceive = 14;
   */
  defaultReceive = false;

  /**
   * @generated from field: string state = 15;
   */
  state = "";

  constructor(data?: PartialMessage<LinkedAccount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.LinkedAccount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "nickname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "canSend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "canReceive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "sendCurrencyCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "sendCurrencyCountryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "receiveCurrencyCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "receiveCurrencyCountryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "defaultSend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "defaultReceive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LinkedAccount {
    return new LinkedAccount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LinkedAccount {
    return new LinkedAccount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LinkedAccount {
    return new LinkedAccount().fromJsonString(jsonString, options);
  }

  static equals(a: LinkedAccount | PlainMessage<LinkedAccount> | undefined, b: LinkedAccount | PlainMessage<LinkedAccount> | undefined): boolean {
    return proto3.util.equals(LinkedAccount, a, b);
  }
}

/**
 * @generated from message backend.v1.GetSignupRequest
 */
export class GetSignupRequest extends Message<GetSignupRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetSignupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetSignupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSignupRequest {
    return new GetSignupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSignupRequest {
    return new GetSignupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSignupRequest {
    return new GetSignupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSignupRequest | PlainMessage<GetSignupRequest> | undefined, b: GetSignupRequest | PlainMessage<GetSignupRequest> | undefined): boolean {
    return proto3.util.equals(GetSignupRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetSignupUserDataRequest
 */
export class SetSignupUserDataRequest extends Message<SetSignupUserDataRequest> {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string firstName = 2;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 3;
   */
  lastName = "";

  /**
   * @generated from field: string email = 4;
   */
  email = "";

  /**
   * @generated from field: string countryCode = 5;
   */
  countryCode = "";

  constructor(data?: PartialMessage<SetSignupUserDataRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetSignupUserDataRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetSignupUserDataRequest {
    return new SetSignupUserDataRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetSignupUserDataRequest {
    return new SetSignupUserDataRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetSignupUserDataRequest {
    return new SetSignupUserDataRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetSignupUserDataRequest | PlainMessage<SetSignupUserDataRequest> | undefined, b: SetSignupUserDataRequest | PlainMessage<SetSignupUserDataRequest> | undefined): boolean {
    return proto3.util.equals(SetSignupUserDataRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetSignupUserDataResponse
 */
export class SetSignupUserDataResponse extends Message<SetSignupUserDataResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SetSignupUserDataResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetSignupUserDataResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetSignupUserDataResponse {
    return new SetSignupUserDataResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetSignupUserDataResponse {
    return new SetSignupUserDataResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetSignupUserDataResponse {
    return new SetSignupUserDataResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetSignupUserDataResponse | PlainMessage<SetSignupUserDataResponse> | undefined, b: SetSignupUserDataResponse | PlainMessage<SetSignupUserDataResponse> | undefined): boolean {
    return proto3.util.equals(SetSignupUserDataResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.SetSignupMobileNumberRequest
 */
export class SetSignupMobileNumberRequest extends Message<SetSignupMobileNumberRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string mobile = 2;
   */
  mobile = "";

  /**
   * @generated from field: string otp = 3;
   */
  otp = "";

  constructor(data?: PartialMessage<SetSignupMobileNumberRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetSignupMobileNumberRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mobile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetSignupMobileNumberRequest {
    return new SetSignupMobileNumberRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetSignupMobileNumberRequest {
    return new SetSignupMobileNumberRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetSignupMobileNumberRequest {
    return new SetSignupMobileNumberRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetSignupMobileNumberRequest | PlainMessage<SetSignupMobileNumberRequest> | undefined, b: SetSignupMobileNumberRequest | PlainMessage<SetSignupMobileNumberRequest> | undefined): boolean {
    return proto3.util.equals(SetSignupMobileNumberRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Signup
 */
export class Signup extends Message<Signup> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string firstName = 2;
   */
  firstName = "";

  /**
   * @generated from field: string lastName = 3;
   */
  lastName = "";

  /**
   * @generated from field: string email = 4;
   */
  email = "";

  /**
   * @generated from field: string countryCode = 5;
   */
  countryCode = "";

  /**
   * @generated from field: string mobileNumber = 6;
   */
  mobileNumber = "";

  /**
   * @generated from field: string userId = 7;
   */
  userId = "";

  /**
   * @generated from field: bool completed = 8;
   */
  completed = false;

  constructor(data?: PartialMessage<Signup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Signup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "firstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "countryCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "mobileNumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Signup {
    return new Signup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Signup {
    return new Signup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Signup {
    return new Signup().fromJsonString(jsonString, options);
  }

  static equals(a: Signup | PlainMessage<Signup> | undefined, b: Signup | PlainMessage<Signup> | undefined): boolean {
    return proto3.util.equals(Signup, a, b);
  }
}

/**
 * @generated from message backend.v1.CompleteSignupRequest
 */
export class CompleteSignupRequest extends Message<CompleteSignupRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string userId = 2;
   */
  userId = "";

  constructor(data?: PartialMessage<CompleteSignupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CompleteSignupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "userId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteSignupRequest {
    return new CompleteSignupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteSignupRequest {
    return new CompleteSignupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteSignupRequest {
    return new CompleteSignupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteSignupRequest | PlainMessage<CompleteSignupRequest> | undefined, b: CompleteSignupRequest | PlainMessage<CompleteSignupRequest> | undefined): boolean {
    return proto3.util.equals(CompleteSignupRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateUserDefaultWalletRequest
 */
export class CreateUserDefaultWalletRequest extends Message<CreateUserDefaultWalletRequest> {
  /**
   * @generated from field: string userID = 1;
   */
  userID = "";

  constructor(data?: PartialMessage<CreateUserDefaultWalletRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateUserDefaultWalletRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "userID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateUserDefaultWalletRequest {
    return new CreateUserDefaultWalletRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateUserDefaultWalletRequest {
    return new CreateUserDefaultWalletRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateUserDefaultWalletRequest {
    return new CreateUserDefaultWalletRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateUserDefaultWalletRequest | PlainMessage<CreateUserDefaultWalletRequest> | undefined, b: CreateUserDefaultWalletRequest | PlainMessage<CreateUserDefaultWalletRequest> | undefined): boolean {
    return proto3.util.equals(CreateUserDefaultWalletRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SendPhoneVerificationRequest
 */
export class SendPhoneVerificationRequest extends Message<SendPhoneVerificationRequest> {
  /**
   * @generated from field: string to = 1;
   */
  to = "";

  constructor(data?: PartialMessage<SendPhoneVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SendPhoneVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendPhoneVerificationRequest {
    return new SendPhoneVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendPhoneVerificationRequest {
    return new SendPhoneVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendPhoneVerificationRequest {
    return new SendPhoneVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendPhoneVerificationRequest | PlainMessage<SendPhoneVerificationRequest> | undefined, b: SendPhoneVerificationRequest | PlainMessage<SendPhoneVerificationRequest> | undefined): boolean {
    return proto3.util.equals(SendPhoneVerificationRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CheckPhoneVerificationRequest
 */
export class CheckPhoneVerificationRequest extends Message<CheckPhoneVerificationRequest> {
  /**
   * @generated from field: string to = 1;
   */
  to = "";

  /**
   * @generated from field: string otp = 2;
   */
  otp = "";

  constructor(data?: PartialMessage<CheckPhoneVerificationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CheckPhoneVerificationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "otp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckPhoneVerificationRequest {
    return new CheckPhoneVerificationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckPhoneVerificationRequest {
    return new CheckPhoneVerificationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckPhoneVerificationRequest {
    return new CheckPhoneVerificationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckPhoneVerificationRequest | PlainMessage<CheckPhoneVerificationRequest> | undefined, b: CheckPhoneVerificationRequest | PlainMessage<CheckPhoneVerificationRequest> | undefined): boolean {
    return proto3.util.equals(CheckPhoneVerificationRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetAgreementRequest
 */
export class GetAgreementRequest extends Message<GetAgreementRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetAgreementRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetAgreementRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgreementRequest {
    return new GetAgreementRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgreementRequest {
    return new GetAgreementRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgreementRequest {
    return new GetAgreementRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgreementRequest | PlainMessage<GetAgreementRequest> | undefined, b: GetAgreementRequest | PlainMessage<GetAgreementRequest> | undefined): boolean {
    return proto3.util.equals(GetAgreementRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Agreement
 */
export class Agreement extends Message<Agreement> {
  /**
   * @generated from field: string content = 1;
   */
  content = "";

  constructor(data?: PartialMessage<Agreement>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Agreement";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Agreement {
    return new Agreement().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Agreement {
    return new Agreement().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Agreement {
    return new Agreement().fromJsonString(jsonString, options);
  }

  static equals(a: Agreement | PlainMessage<Agreement> | undefined, b: Agreement | PlainMessage<Agreement> | undefined): boolean {
    return proto3.util.equals(Agreement, a, b);
  }
}

/**
 * @generated from message backend.v1.SignAgreementsRequest
 */
export class SignAgreementsRequest extends Message<SignAgreementsRequest> {
  /**
   * @generated from field: repeated string agreementIds = 1;
   */
  agreementIds: string[] = [];

  /**
   * @generated from field: string userId = 2;
   */
  userId = "";

  /**
   * @generated from field: string ipAddress = 3;
   */
  ipAddress = "";

  constructor(data?: PartialMessage<SignAgreementsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SignAgreementsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agreementIds", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "userId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ipAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignAgreementsRequest {
    return new SignAgreementsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignAgreementsRequest {
    return new SignAgreementsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignAgreementsRequest {
    return new SignAgreementsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignAgreementsRequest | PlainMessage<SignAgreementsRequest> | undefined, b: SignAgreementsRequest | PlainMessage<SignAgreementsRequest> | undefined): boolean {
    return proto3.util.equals(SignAgreementsRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SignAgreementsResponse
 */
export class SignAgreementsResponse extends Message<SignAgreementsResponse> {
  /**
   * @generated from field: bool signed = 1;
   */
  signed = false;

  constructor(data?: PartialMessage<SignAgreementsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SignAgreementsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "signed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignAgreementsResponse {
    return new SignAgreementsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignAgreementsResponse {
    return new SignAgreementsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignAgreementsResponse {
    return new SignAgreementsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignAgreementsResponse | PlainMessage<SignAgreementsResponse> | undefined, b: SignAgreementsResponse | PlainMessage<SignAgreementsResponse> | undefined): boolean {
    return proto3.util.equals(SignAgreementsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.JoinWaitlistRequest
 */
export class JoinWaitlistRequest extends Message<JoinWaitlistRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string country_code = 2;
   */
  countryCode = "";

  /**
   * @generated from field: string full_name = 3;
   */
  fullName = "";

  /**
   * @generated from field: bool beta_opt_in = 4;
   */
  betaOptIn = false;

  /**
   * @generated from field: optional string mug_id = 5;
   */
  mugId?: string;

  constructor(data?: PartialMessage<JoinWaitlistRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.JoinWaitlistRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "beta_opt_in", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "mug_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinWaitlistRequest {
    return new JoinWaitlistRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinWaitlistRequest {
    return new JoinWaitlistRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinWaitlistRequest {
    return new JoinWaitlistRequest().fromJsonString(jsonString, options);
  }

  static equals(a: JoinWaitlistRequest | PlainMessage<JoinWaitlistRequest> | undefined, b: JoinWaitlistRequest | PlainMessage<JoinWaitlistRequest> | undefined): boolean {
    return proto3.util.equals(JoinWaitlistRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.JoinWaitlistResponse
 */
export class JoinWaitlistResponse extends Message<JoinWaitlistResponse> {
  constructor(data?: PartialMessage<JoinWaitlistResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.JoinWaitlistResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JoinWaitlistResponse {
    return new JoinWaitlistResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JoinWaitlistResponse {
    return new JoinWaitlistResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JoinWaitlistResponse {
    return new JoinWaitlistResponse().fromJsonString(jsonString, options);
  }

  static equals(a: JoinWaitlistResponse | PlainMessage<JoinWaitlistResponse> | undefined, b: JoinWaitlistResponse | PlainMessage<JoinWaitlistResponse> | undefined): boolean {
    return proto3.util.equals(JoinWaitlistResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.IsMugAvailableRequest
 */
export class IsMugAvailableRequest extends Message<IsMugAvailableRequest> {
  /**
   * @generated from field: string mug_id = 1;
   */
  mugId = "";

  constructor(data?: PartialMessage<IsMugAvailableRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.IsMugAvailableRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "mug_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IsMugAvailableRequest {
    return new IsMugAvailableRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IsMugAvailableRequest {
    return new IsMugAvailableRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IsMugAvailableRequest {
    return new IsMugAvailableRequest().fromJsonString(jsonString, options);
  }

  static equals(a: IsMugAvailableRequest | PlainMessage<IsMugAvailableRequest> | undefined, b: IsMugAvailableRequest | PlainMessage<IsMugAvailableRequest> | undefined): boolean {
    return proto3.util.equals(IsMugAvailableRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.IsMugAvailableResponse
 */
export class IsMugAvailableResponse extends Message<IsMugAvailableResponse> {
  /**
   * @generated from field: bool available = 1;
   */
  available = false;

  constructor(data?: PartialMessage<IsMugAvailableResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.IsMugAvailableResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IsMugAvailableResponse {
    return new IsMugAvailableResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IsMugAvailableResponse {
    return new IsMugAvailableResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IsMugAvailableResponse {
    return new IsMugAvailableResponse().fromJsonString(jsonString, options);
  }

  static equals(a: IsMugAvailableResponse | PlainMessage<IsMugAvailableResponse> | undefined, b: IsMugAvailableResponse | PlainMessage<IsMugAvailableResponse> | undefined): boolean {
    return proto3.util.equals(IsMugAvailableResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetLinkedAccountsResponse
 */
export class GetLinkedAccountsResponse extends Message<GetLinkedAccountsResponse> {
  /**
   * @generated from field: repeated backend.v1.LinkedAccount linkedAccounts = 1;
   */
  linkedAccounts: LinkedAccount[] = [];

  constructor(data?: PartialMessage<GetLinkedAccountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetLinkedAccountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "linkedAccounts", kind: "message", T: LinkedAccount, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLinkedAccountsResponse {
    return new GetLinkedAccountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLinkedAccountsResponse {
    return new GetLinkedAccountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLinkedAccountsResponse {
    return new GetLinkedAccountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLinkedAccountsResponse | PlainMessage<GetLinkedAccountsResponse> | undefined, b: GetLinkedAccountsResponse | PlainMessage<GetLinkedAccountsResponse> | undefined): boolean {
    return proto3.util.equals(GetLinkedAccountsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetLinkedAccountRequest
 */
export class GetLinkedAccountRequest extends Message<GetLinkedAccountRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetLinkedAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetLinkedAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLinkedAccountRequest {
    return new GetLinkedAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLinkedAccountRequest {
    return new GetLinkedAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLinkedAccountRequest {
    return new GetLinkedAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLinkedAccountRequest | PlainMessage<GetLinkedAccountRequest> | undefined, b: GetLinkedAccountRequest | PlainMessage<GetLinkedAccountRequest> | undefined): boolean {
    return proto3.util.equals(GetLinkedAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetNicknameLinkedAccountRequest
 */
export class SetNicknameLinkedAccountRequest extends Message<SetNicknameLinkedAccountRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string nickname = 2;
   */
  nickname = "";

  constructor(data?: PartialMessage<SetNicknameLinkedAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetNicknameLinkedAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nickname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetNicknameLinkedAccountRequest {
    return new SetNicknameLinkedAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetNicknameLinkedAccountRequest {
    return new SetNicknameLinkedAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetNicknameLinkedAccountRequest {
    return new SetNicknameLinkedAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetNicknameLinkedAccountRequest | PlainMessage<SetNicknameLinkedAccountRequest> | undefined, b: SetNicknameLinkedAccountRequest | PlainMessage<SetNicknameLinkedAccountRequest> | undefined): boolean {
    return proto3.util.equals(SetNicknameLinkedAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.DeleteLinkedAccountRequest
 */
export class DeleteLinkedAccountRequest extends Message<DeleteLinkedAccountRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteLinkedAccountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.DeleteLinkedAccountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteLinkedAccountRequest {
    return new DeleteLinkedAccountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteLinkedAccountRequest {
    return new DeleteLinkedAccountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteLinkedAccountRequest {
    return new DeleteLinkedAccountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteLinkedAccountRequest | PlainMessage<DeleteLinkedAccountRequest> | undefined, b: DeleteLinkedAccountRequest | PlainMessage<DeleteLinkedAccountRequest> | undefined): boolean {
    return proto3.util.equals(DeleteLinkedAccountRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.Country
 */
export class Country extends Message<Country> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<Country>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Country";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Country {
    return new Country().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Country {
    return new Country().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Country {
    return new Country().fromJsonString(jsonString, options);
  }

  static equals(a: Country | PlainMessage<Country> | undefined, b: Country | PlainMessage<Country> | undefined): boolean {
    return proto3.util.equals(Country, a, b);
  }
}

/**
 * @generated from message backend.v1.GetCountriesResponse
 */
export class GetCountriesResponse extends Message<GetCountriesResponse> {
  /**
   * @generated from field: repeated backend.v1.Country countries = 1;
   */
  countries: Country[] = [];

  constructor(data?: PartialMessage<GetCountriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetCountriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "countries", kind: "message", T: Country, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCountriesResponse {
    return new GetCountriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCountriesResponse {
    return new GetCountriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCountriesResponse {
    return new GetCountriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCountriesResponse | PlainMessage<GetCountriesResponse> | undefined, b: GetCountriesResponse | PlainMessage<GetCountriesResponse> | undefined): boolean {
    return proto3.util.equals(GetCountriesResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CanSignupRequest
 */
export class CanSignupRequest extends Message<CanSignupRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<CanSignupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CanSignupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CanSignupRequest {
    return new CanSignupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CanSignupRequest {
    return new CanSignupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CanSignupRequest {
    return new CanSignupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CanSignupRequest | PlainMessage<CanSignupRequest> | undefined, b: CanSignupRequest | PlainMessage<CanSignupRequest> | undefined): boolean {
    return proto3.util.equals(CanSignupRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CanSignupResponse
 */
export class CanSignupResponse extends Message<CanSignupResponse> {
  /**
   * @generated from field: bool canSignup = 1;
   */
  canSignup = false;

  constructor(data?: PartialMessage<CanSignupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CanSignupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "canSignup", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CanSignupResponse {
    return new CanSignupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CanSignupResponse {
    return new CanSignupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CanSignupResponse {
    return new CanSignupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CanSignupResponse | PlainMessage<CanSignupResponse> | undefined, b: CanSignupResponse | PlainMessage<CanSignupResponse> | undefined): boolean {
    return proto3.util.equals(CanSignupResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.SetSignupCompleteRequest
 */
export class SetSignupCompleteRequest extends Message<SetSignupCompleteRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string userId = 2;
   */
  userId = "";

  constructor(data?: PartialMessage<SetSignupCompleteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetSignupCompleteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "userId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetSignupCompleteRequest {
    return new SetSignupCompleteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetSignupCompleteRequest {
    return new SetSignupCompleteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetSignupCompleteRequest {
    return new SetSignupCompleteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetSignupCompleteRequest | PlainMessage<SetSignupCompleteRequest> | undefined, b: SetSignupCompleteRequest | PlainMessage<SetSignupCompleteRequest> | undefined): boolean {
    return proto3.util.equals(SetSignupCompleteRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.LookupTransactionRequest
 */
export class LookupTransactionRequest extends Message<LookupTransactionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<LookupTransactionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.LookupTransactionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LookupTransactionRequest {
    return new LookupTransactionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LookupTransactionRequest {
    return new LookupTransactionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LookupTransactionRequest {
    return new LookupTransactionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LookupTransactionRequest | PlainMessage<LookupTransactionRequest> | undefined, b: LookupTransactionRequest | PlainMessage<LookupTransactionRequest> | undefined): boolean {
    return proto3.util.equals(LookupTransactionRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetCurrentWalletResponse
 */
export class GetCurrentWalletResponse extends Message<GetCurrentWalletResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string country = 2;
   */
  country = "";

  constructor(data?: PartialMessage<GetCurrentWalletResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetCurrentWalletResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCurrentWalletResponse {
    return new GetCurrentWalletResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCurrentWalletResponse {
    return new GetCurrentWalletResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCurrentWalletResponse {
    return new GetCurrentWalletResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCurrentWalletResponse | PlainMessage<GetCurrentWalletResponse> | undefined, b: GetCurrentWalletResponse | PlainMessage<GetCurrentWalletResponse> | undefined): boolean {
    return proto3.util.equals(GetCurrentWalletResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.Limit
 */
export class Limit extends Message<Limit> {
  /**
   * @generated from field: backend.v1.LimitAmount Annual = 1;
   */
  Annual?: LimitAmount;

  /**
   * @generated from field: backend.v1.LimitAmount Daily = 2;
   */
  Daily?: LimitAmount;

  /**
   * @generated from field: backend.v1.LimitAmount Monthly = 3;
   */
  Monthly?: LimitAmount;

  /**
   * @generated from field: backend.v1.LimitAmount WalletHold = 4;
   */
  WalletHold?: LimitAmount;

  constructor(data?: PartialMessage<Limit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Limit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "Annual", kind: "message", T: LimitAmount },
    { no: 2, name: "Daily", kind: "message", T: LimitAmount },
    { no: 3, name: "Monthly", kind: "message", T: LimitAmount },
    { no: 4, name: "WalletHold", kind: "message", T: LimitAmount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Limit {
    return new Limit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Limit {
    return new Limit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Limit {
    return new Limit().fromJsonString(jsonString, options);
  }

  static equals(a: Limit | PlainMessage<Limit> | undefined, b: Limit | PlainMessage<Limit> | undefined): boolean {
    return proto3.util.equals(Limit, a, b);
  }
}

/**
 * @generated from message backend.v1.LimitAmount
 */
export class LimitAmount extends Message<LimitAmount> {
  /**
   * @generated from field: string remaining = 1;
   */
  remaining = "";

  /**
   * @generated from field: string total = 2;
   */
  total = "";

  /**
   * @generated from field: int32 percentage = 3;
   */
  percentage = 0;

  constructor(data?: PartialMessage<LimitAmount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.LimitAmount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "remaining", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LimitAmount {
    return new LimitAmount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LimitAmount {
    return new LimitAmount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LimitAmount {
    return new LimitAmount().fromJsonString(jsonString, options);
  }

  static equals(a: LimitAmount | PlainMessage<LimitAmount> | undefined, b: LimitAmount | PlainMessage<LimitAmount> | undefined): boolean {
    return proto3.util.equals(LimitAmount, a, b);
  }
}

/**
 * @generated from message backend.v1.WalletAddressValidRequest
 */
export class WalletAddressValidRequest extends Message<WalletAddressValidRequest> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<WalletAddressValidRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.WalletAddressValidRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WalletAddressValidRequest {
    return new WalletAddressValidRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WalletAddressValidRequest {
    return new WalletAddressValidRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WalletAddressValidRequest {
    return new WalletAddressValidRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WalletAddressValidRequest | PlainMessage<WalletAddressValidRequest> | undefined, b: WalletAddressValidRequest | PlainMessage<WalletAddressValidRequest> | undefined): boolean {
    return proto3.util.equals(WalletAddressValidRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.WalletAddressValidResponse
 */
export class WalletAddressValidResponse extends Message<WalletAddressValidResponse> {
  /**
   * @generated from field: bool exists = 1;
   */
  exists = false;

  constructor(data?: PartialMessage<WalletAddressValidResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.WalletAddressValidResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WalletAddressValidResponse {
    return new WalletAddressValidResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WalletAddressValidResponse {
    return new WalletAddressValidResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WalletAddressValidResponse {
    return new WalletAddressValidResponse().fromJsonString(jsonString, options);
  }

  static equals(a: WalletAddressValidResponse | PlainMessage<WalletAddressValidResponse> | undefined, b: WalletAddressValidResponse | PlainMessage<WalletAddressValidResponse> | undefined): boolean {
    return proto3.util.equals(WalletAddressValidResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateWalletAddressRequest
 */
export class CreateWalletAddressRequest extends Message<CreateWalletAddressRequest> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string asset = 2;
   */
  asset = "";

  /**
   * @generated from field: int32 assetScale = 3;
   */
  assetScale = 0;

  /**
   * @generated from field: string alias = 4;
   */
  alias = "";

  constructor(data?: PartialMessage<CreateWalletAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateWalletAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "asset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "assetScale", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "alias", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWalletAddressRequest {
    return new CreateWalletAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWalletAddressRequest {
    return new CreateWalletAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWalletAddressRequest {
    return new CreateWalletAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWalletAddressRequest | PlainMessage<CreateWalletAddressRequest> | undefined, b: CreateWalletAddressRequest | PlainMessage<CreateWalletAddressRequest> | undefined): boolean {
    return proto3.util.equals(CreateWalletAddressRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetWalletNameRequest
 */
export class SetWalletNameRequest extends Message<SetWalletNameRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  constructor(data?: PartialMessage<SetWalletNameRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetWalletNameRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetWalletNameRequest {
    return new SetWalletNameRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetWalletNameRequest {
    return new SetWalletNameRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetWalletNameRequest {
    return new SetWalletNameRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetWalletNameRequest | PlainMessage<SetWalletNameRequest> | undefined, b: SetWalletNameRequest | PlainMessage<SetWalletNameRequest> | undefined): boolean {
    return proto3.util.equals(SetWalletNameRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPublicWalletDetailsRequest
 */
export class GetPublicWalletDetailsRequest extends Message<GetPublicWalletDetailsRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetPublicWalletDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPublicWalletDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPublicWalletDetailsRequest {
    return new GetPublicWalletDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPublicWalletDetailsRequest {
    return new GetPublicWalletDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPublicWalletDetailsRequest {
    return new GetPublicWalletDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPublicWalletDetailsRequest | PlainMessage<GetPublicWalletDetailsRequest> | undefined, b: GetPublicWalletDetailsRequest | PlainMessage<GetPublicWalletDetailsRequest> | undefined): boolean {
    return proto3.util.equals(GetPublicWalletDetailsRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPublicWalletDetailsResponse
 */
export class GetPublicWalletDetailsResponse extends Message<GetPublicWalletDetailsResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string publicName = 2;
   */
  publicName = "";

  constructor(data?: PartialMessage<GetPublicWalletDetailsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPublicWalletDetailsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "publicName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPublicWalletDetailsResponse {
    return new GetPublicWalletDetailsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPublicWalletDetailsResponse {
    return new GetPublicWalletDetailsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPublicWalletDetailsResponse {
    return new GetPublicWalletDetailsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPublicWalletDetailsResponse | PlainMessage<GetPublicWalletDetailsResponse> | undefined, b: GetPublicWalletDetailsResponse | PlainMessage<GetPublicWalletDetailsResponse> | undefined): boolean {
    return proto3.util.equals(GetPublicWalletDetailsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.ConfiguredLimit
 */
export class ConfiguredLimit extends Message<ConfiguredLimit> {
  /**
   * @generated from field: string foreignId = 1;
   */
  foreignId = "";

  /**
   * @generated from field: string foreignDisplay = 2;
   */
  foreignDisplay = "";

  /**
   * @generated from field: string foreignType = 3;
   */
  foreignType = "";

  /**
   * @generated from field: backend.v1.Amount daily = 4;
   */
  daily?: Amount;

  /**
   * @generated from field: backend.v1.Amount monthly = 5;
   */
  monthly?: Amount;

  /**
   * @generated from field: backend.v1.Amount overall = 6;
   */
  overall?: Amount;

  constructor(data?: PartialMessage<ConfiguredLimit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ConfiguredLimit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "foreignId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "foreignDisplay", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "foreignType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "daily", kind: "message", T: Amount },
    { no: 5, name: "monthly", kind: "message", T: Amount },
    { no: 6, name: "overall", kind: "message", T: Amount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfiguredLimit {
    return new ConfiguredLimit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfiguredLimit {
    return new ConfiguredLimit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfiguredLimit {
    return new ConfiguredLimit().fromJsonString(jsonString, options);
  }

  static equals(a: ConfiguredLimit | PlainMessage<ConfiguredLimit> | undefined, b: ConfiguredLimit | PlainMessage<ConfiguredLimit> | undefined): boolean {
    return proto3.util.equals(ConfiguredLimit, a, b);
  }
}

/**
 * @generated from message backend.v1.Contact
 */
export class Contact extends Message<Contact> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string payment_pointer = 2;
   */
  paymentPointer = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string wallet_id = 4;
   */
  walletId = "";

  constructor(data?: PartialMessage<Contact>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Contact";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_pointer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "wallet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Contact {
    return new Contact().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Contact {
    return new Contact().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Contact {
    return new Contact().fromJsonString(jsonString, options);
  }

  static equals(a: Contact | PlainMessage<Contact> | undefined, b: Contact | PlainMessage<Contact> | undefined): boolean {
    return proto3.util.equals(Contact, a, b);
  }
}

/**
 * @generated from message backend.v1.ListContactsRequest
 */
export class ListContactsRequest extends Message<ListContactsRequest> {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize = 0;

  /**
   * @generated from field: optional string page_token = 2;
   */
  pageToken?: string;

  /**
   * @generated from field: optional string order_by = 3;
   */
  orderBy?: string;

  constructor(data?: PartialMessage<ListContactsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListContactsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "order_by", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListContactsRequest {
    return new ListContactsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListContactsRequest {
    return new ListContactsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListContactsRequest {
    return new ListContactsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListContactsRequest | PlainMessage<ListContactsRequest> | undefined, b: ListContactsRequest | PlainMessage<ListContactsRequest> | undefined): boolean {
    return proto3.util.equals(ListContactsRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.ListContactsResponse
 */
export class ListContactsResponse extends Message<ListContactsResponse> {
  /**
   * @generated from field: repeated backend.v1.Contact contacts = 1;
   */
  contacts: Contact[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListContactsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListContactsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts", kind: "message", T: Contact, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListContactsResponse {
    return new ListContactsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListContactsResponse {
    return new ListContactsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListContactsResponse {
    return new ListContactsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListContactsResponse | PlainMessage<ListContactsResponse> | undefined, b: ListContactsResponse | PlainMessage<ListContactsResponse> | undefined): boolean {
    return proto3.util.equals(ListContactsResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateContactRequest
 */
export class CreateContactRequest extends Message<CreateContactRequest> {
  /**
   * @generated from field: string payment_pointer = 1;
   */
  paymentPointer = "";

  constructor(data?: PartialMessage<CreateContactRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateContactRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_pointer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateContactRequest {
    return new CreateContactRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateContactRequest {
    return new CreateContactRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateContactRequest {
    return new CreateContactRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateContactRequest | PlainMessage<CreateContactRequest> | undefined, b: CreateContactRequest | PlainMessage<CreateContactRequest> | undefined): boolean {
    return proto3.util.equals(CreateContactRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.ListIdentitiesResponse
 */
export class ListIdentitiesResponse extends Message<ListIdentitiesResponse> {
  /**
   * @generated from field: repeated backend.v1.Identity identities = 1;
   */
  identities: Identity[] = [];

  constructor(data?: PartialMessage<ListIdentitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListIdentitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "identities", kind: "message", T: Identity, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIdentitiesResponse {
    return new ListIdentitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIdentitiesResponse {
    return new ListIdentitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIdentitiesResponse {
    return new ListIdentitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListIdentitiesResponse | PlainMessage<ListIdentitiesResponse> | undefined, b: ListIdentitiesResponse | PlainMessage<ListIdentitiesResponse> | undefined): boolean {
    return proto3.util.equals(ListIdentitiesResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.Identity
 */
export class Identity extends Message<Identity> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string wallet = 2;
   */
  wallet = "";

  /**
   * @generated from field: string platform = 3;
   */
  platform = "";

  /**
   * @generated from field: string identifier = 4;
   */
  identifier = "";

  /**
   * @generated from field: string state = 5;
   */
  state = "";

  /**
   * @generated from field: string key_id = 6;
   */
  keyId = "";

  /**
   * @generated from field: string signature = 7;
   */
  signature = "";

  /**
   * @generated from field: string signature_hash = 8;
   */
  signatureHash = "";

  /**
   * @generated from field: string proof = 9;
   */
  proof = "";

  /**
   * @generated from field: string ctime = 10;
   */
  ctime = "";

  /**
   * @generated from field: bool public = 11;
   */
  public = false;

  /**
   * @generated from field: google.protobuf.Timestamp verified_at = 12;
   */
  verifiedAt?: Timestamp;

  /**
   * @generated from field: string wallet_id = 13;
   */
  walletId = "";

  /**
   * @generated from field: optional string txt_record = 14;
   */
  txtRecord?: string;

  constructor(data?: PartialMessage<Identity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.Identity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "wallet", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "signature_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "proof", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "ctime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "verified_at", kind: "message", T: Timestamp },
    { no: 13, name: "wallet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "txt_record", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Identity {
    return new Identity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Identity {
    return new Identity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Identity {
    return new Identity().fromJsonString(jsonString, options);
  }

  static equals(a: Identity | PlainMessage<Identity> | undefined, b: Identity | PlainMessage<Identity> | undefined): boolean {
    return proto3.util.equals(Identity, a, b);
  }
}

/**
 * @generated from message backend.v1.IdentityVerificationInstructions
 */
export class IdentityVerificationInstructions extends Message<IdentityVerificationInstructions> {
  /**
   * @generated from field: string identity_id = 1;
   */
  identityId = "";

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string instructions = 3;
   */
  instructions = "";

  constructor(data?: PartialMessage<IdentityVerificationInstructions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.IdentityVerificationInstructions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "identity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "instructions", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IdentityVerificationInstructions {
    return new IdentityVerificationInstructions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IdentityVerificationInstructions {
    return new IdentityVerificationInstructions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IdentityVerificationInstructions {
    return new IdentityVerificationInstructions().fromJsonString(jsonString, options);
  }

  static equals(a: IdentityVerificationInstructions | PlainMessage<IdentityVerificationInstructions> | undefined, b: IdentityVerificationInstructions | PlainMessage<IdentityVerificationInstructions> | undefined): boolean {
    return proto3.util.equals(IdentityVerificationInstructions, a, b);
  }
}

/**
 * @generated from message backend.v1.DeleteIdentityRequest
 */
export class DeleteIdentityRequest extends Message<DeleteIdentityRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteIdentityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.DeleteIdentityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIdentityRequest {
    return new DeleteIdentityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIdentityRequest {
    return new DeleteIdentityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIdentityRequest {
    return new DeleteIdentityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIdentityRequest | PlainMessage<DeleteIdentityRequest> | undefined, b: DeleteIdentityRequest | PlainMessage<DeleteIdentityRequest> | undefined): boolean {
    return proto3.util.equals(DeleteIdentityRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.SetIdentityPublicRequest
 */
export class SetIdentityPublicRequest extends Message<SetIdentityPublicRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: bool public = 2;
   */
  public = false;

  constructor(data?: PartialMessage<SetIdentityPublicRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.SetIdentityPublicRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "public", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetIdentityPublicRequest {
    return new SetIdentityPublicRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetIdentityPublicRequest {
    return new SetIdentityPublicRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetIdentityPublicRequest {
    return new SetIdentityPublicRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetIdentityPublicRequest | PlainMessage<SetIdentityPublicRequest> | undefined, b: SetIdentityPublicRequest | PlainMessage<SetIdentityPublicRequest> | undefined): boolean {
    return proto3.util.equals(SetIdentityPublicRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.ListPublicIdentitiesRequest
 */
export class ListPublicIdentitiesRequest extends Message<ListPublicIdentitiesRequest> {
  /**
   * @generated from field: string wallet_id = 1;
   */
  walletId = "";

  constructor(data?: PartialMessage<ListPublicIdentitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.ListPublicIdentitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "wallet_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPublicIdentitiesRequest {
    return new ListPublicIdentitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPublicIdentitiesRequest {
    return new ListPublicIdentitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPublicIdentitiesRequest {
    return new ListPublicIdentitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPublicIdentitiesRequest | PlainMessage<ListPublicIdentitiesRequest> | undefined, b: ListPublicIdentitiesRequest | PlainMessage<ListPublicIdentitiesRequest> | undefined): boolean {
    return proto3.util.equals(ListPublicIdentitiesRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.KYCStatusResponse
 */
export class KYCStatusResponse extends Message<KYCStatusResponse> {
  /**
   * @generated from field: int32 kyc_status = 1;
   */
  kycStatus = 0;

  constructor(data?: PartialMessage<KYCStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.KYCStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kyc_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KYCStatusResponse {
    return new KYCStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KYCStatusResponse {
    return new KYCStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KYCStatusResponse {
    return new KYCStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: KYCStatusResponse | PlainMessage<KYCStatusResponse> | undefined, b: KYCStatusResponse | PlainMessage<KYCStatusResponse> | undefined): boolean {
    return proto3.util.equals(KYCStatusResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.KYCPersonaInquiryRequest
 */
export class KYCPersonaInquiryRequest extends Message<KYCPersonaInquiryRequest> {
  /**
   * @generated from field: optional string idempotency_key = 1;
   */
  idempotencyKey?: string;

  constructor(data?: PartialMessage<KYCPersonaInquiryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.KYCPersonaInquiryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "idempotency_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KYCPersonaInquiryRequest {
    return new KYCPersonaInquiryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KYCPersonaInquiryRequest {
    return new KYCPersonaInquiryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KYCPersonaInquiryRequest {
    return new KYCPersonaInquiryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: KYCPersonaInquiryRequest | PlainMessage<KYCPersonaInquiryRequest> | undefined, b: KYCPersonaInquiryRequest | PlainMessage<KYCPersonaInquiryRequest> | undefined): boolean {
    return proto3.util.equals(KYCPersonaInquiryRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.KYCPersonaInquiryResponse
 */
export class KYCPersonaInquiryResponse extends Message<KYCPersonaInquiryResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: optional string session_token = 2 [deprecated = true];
   * @deprecated
   */
  sessionToken?: string;

  constructor(data?: PartialMessage<KYCPersonaInquiryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.KYCPersonaInquiryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KYCPersonaInquiryResponse {
    return new KYCPersonaInquiryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KYCPersonaInquiryResponse {
    return new KYCPersonaInquiryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KYCPersonaInquiryResponse {
    return new KYCPersonaInquiryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: KYCPersonaInquiryResponse | PlainMessage<KYCPersonaInquiryResponse> | undefined, b: KYCPersonaInquiryResponse | PlainMessage<KYCPersonaInquiryResponse> | undefined): boolean {
    return proto3.util.equals(KYCPersonaInquiryResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateTwitterAuthURLResponse
 */
export class CreateTwitterAuthURLResponse extends Message<CreateTwitterAuthURLResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<CreateTwitterAuthURLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateTwitterAuthURLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTwitterAuthURLResponse {
    return new CreateTwitterAuthURLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTwitterAuthURLResponse {
    return new CreateTwitterAuthURLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTwitterAuthURLResponse {
    return new CreateTwitterAuthURLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTwitterAuthURLResponse | PlainMessage<CreateTwitterAuthURLResponse> | undefined, b: CreateTwitterAuthURLResponse | PlainMessage<CreateTwitterAuthURLResponse> | undefined): boolean {
    return proto3.util.equals(CreateTwitterAuthURLResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.TwitterCallbackRequest
 */
export class TwitterCallbackRequest extends Message<TwitterCallbackRequest> {
  /**
   * @generated from field: string state = 1;
   */
  state = "";

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  constructor(data?: PartialMessage<TwitterCallbackRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.TwitterCallbackRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TwitterCallbackRequest {
    return new TwitterCallbackRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TwitterCallbackRequest {
    return new TwitterCallbackRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TwitterCallbackRequest {
    return new TwitterCallbackRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TwitterCallbackRequest | PlainMessage<TwitterCallbackRequest> | undefined, b: TwitterCallbackRequest | PlainMessage<TwitterCallbackRequest> | undefined): boolean {
    return proto3.util.equals(TwitterCallbackRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.TwitterCallbackResponse
 */
export class TwitterCallbackResponse extends Message<TwitterCallbackResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<TwitterCallbackResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.TwitterCallbackResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TwitterCallbackResponse {
    return new TwitterCallbackResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TwitterCallbackResponse {
    return new TwitterCallbackResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TwitterCallbackResponse {
    return new TwitterCallbackResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TwitterCallbackResponse | PlainMessage<TwitterCallbackResponse> | undefined, b: TwitterCallbackResponse | PlainMessage<TwitterCallbackResponse> | undefined): boolean {
    return proto3.util.equals(TwitterCallbackResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.DiscordCallbackRequest
 */
export class DiscordCallbackRequest extends Message<DiscordCallbackRequest> {
  /**
   * @generated from field: string state = 1;
   */
  state = "";

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  constructor(data?: PartialMessage<DiscordCallbackRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.DiscordCallbackRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DiscordCallbackRequest {
    return new DiscordCallbackRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DiscordCallbackRequest {
    return new DiscordCallbackRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DiscordCallbackRequest {
    return new DiscordCallbackRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DiscordCallbackRequest | PlainMessage<DiscordCallbackRequest> | undefined, b: DiscordCallbackRequest | PlainMessage<DiscordCallbackRequest> | undefined): boolean {
    return proto3.util.equals(DiscordCallbackRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.DiscordCallbackResponse
 */
export class DiscordCallbackResponse extends Message<DiscordCallbackResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DiscordCallbackResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.DiscordCallbackResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DiscordCallbackResponse {
    return new DiscordCallbackResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DiscordCallbackResponse {
    return new DiscordCallbackResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DiscordCallbackResponse {
    return new DiscordCallbackResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DiscordCallbackResponse | PlainMessage<DiscordCallbackResponse> | undefined, b: DiscordCallbackResponse | PlainMessage<DiscordCallbackResponse> | undefined): boolean {
    return proto3.util.equals(DiscordCallbackResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateDiscordAuthURLResponse
 */
export class CreateDiscordAuthURLResponse extends Message<CreateDiscordAuthURLResponse> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<CreateDiscordAuthURLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateDiscordAuthURLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDiscordAuthURLResponse {
    return new CreateDiscordAuthURLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDiscordAuthURLResponse {
    return new CreateDiscordAuthURLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDiscordAuthURLResponse {
    return new CreateDiscordAuthURLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDiscordAuthURLResponse | PlainMessage<CreateDiscordAuthURLResponse> | undefined, b: CreateDiscordAuthURLResponse | PlainMessage<CreateDiscordAuthURLResponse> | undefined): boolean {
    return proto3.util.equals(CreateDiscordAuthURLResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetIdentityRequest
 */
export class GetIdentityRequest extends Message<GetIdentityRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetIdentityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetIdentityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityRequest {
    return new GetIdentityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityRequest {
    return new GetIdentityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityRequest {
    return new GetIdentityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityRequest | PlainMessage<GetIdentityRequest> | undefined, b: GetIdentityRequest | PlainMessage<GetIdentityRequest> | undefined): boolean {
    return proto3.util.equals(GetIdentityRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetIdentityResponse
 */
export class GetIdentityResponse extends Message<GetIdentityResponse> {
  /**
   * @generated from field: backend.v1.Identity identity = 1;
   */
  identity?: Identity;

  constructor(data?: PartialMessage<GetIdentityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetIdentityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "identity", kind: "message", T: Identity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityResponse {
    return new GetIdentityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityResponse {
    return new GetIdentityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityResponse {
    return new GetIdentityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityResponse | PlainMessage<GetIdentityResponse> | undefined, b: GetIdentityResponse | PlainMessage<GetIdentityResponse> | undefined): boolean {
    return proto3.util.equals(GetIdentityResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.GetIdentityBySignatureHashRequest
 */
export class GetIdentityBySignatureHashRequest extends Message<GetIdentityBySignatureHashRequest> {
  /**
   * @generated from field: string signature_hash = 1;
   */
  signatureHash = "";

  constructor(data?: PartialMessage<GetIdentityBySignatureHashRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetIdentityBySignatureHashRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "signature_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityBySignatureHashRequest {
    return new GetIdentityBySignatureHashRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityBySignatureHashRequest {
    return new GetIdentityBySignatureHashRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityBySignatureHashRequest {
    return new GetIdentityBySignatureHashRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityBySignatureHashRequest | PlainMessage<GetIdentityBySignatureHashRequest> | undefined, b: GetIdentityBySignatureHashRequest | PlainMessage<GetIdentityBySignatureHashRequest> | undefined): boolean {
    return proto3.util.equals(GetIdentityBySignatureHashRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPaymentAddressRequest
 */
export class GetPaymentAddressRequest extends Message<GetPaymentAddressRequest> {
  /**
   * @generated from field: string address = 1;
   */
  address = "";

  constructor(data?: PartialMessage<GetPaymentAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPaymentAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentAddressRequest {
    return new GetPaymentAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentAddressRequest {
    return new GetPaymentAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentAddressRequest {
    return new GetPaymentAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentAddressRequest | PlainMessage<GetPaymentAddressRequest> | undefined, b: GetPaymentAddressRequest | PlainMessage<GetPaymentAddressRequest> | undefined): boolean {
    return proto3.util.equals(GetPaymentAddressRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.GetPaymentAddressResponse
 */
export class GetPaymentAddressResponse extends Message<GetPaymentAddressResponse> {
  /**
   * @generated from field: string wallet_url = 1;
   */
  walletUrl = "";

  /**
   * wallet, twitter
   *
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * url or twitter handle
   *
   * @generated from field: string handle = 3;
   */
  handle = "";

  /**
   * @generated from field: bool canSendToAddress = 4;
   */
  canSendToAddress = false;

  constructor(data?: PartialMessage<GetPaymentAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.GetPaymentAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "wallet_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "canSendToAddress", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentAddressResponse {
    return new GetPaymentAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentAddressResponse {
    return new GetPaymentAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentAddressResponse {
    return new GetPaymentAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentAddressResponse | PlainMessage<GetPaymentAddressResponse> | undefined, b: GetPaymentAddressResponse | PlainMessage<GetPaymentAddressResponse> | undefined): boolean {
    return proto3.util.equals(GetPaymentAddressResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateDomainIdentityRequest
 */
export class CreateDomainIdentityRequest extends Message<CreateDomainIdentityRequest> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<CreateDomainIdentityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateDomainIdentityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDomainIdentityRequest {
    return new CreateDomainIdentityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDomainIdentityRequest {
    return new CreateDomainIdentityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDomainIdentityRequest {
    return new CreateDomainIdentityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDomainIdentityRequest | PlainMessage<CreateDomainIdentityRequest> | undefined, b: CreateDomainIdentityRequest | PlainMessage<CreateDomainIdentityRequest> | undefined): boolean {
    return proto3.util.equals(CreateDomainIdentityRequest, a, b);
  }
}

/**
 * @generated from message backend.v1.CreateDomainIdentityResponse
 */
export class CreateDomainIdentityResponse extends Message<CreateDomainIdentityResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<CreateDomainIdentityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.CreateDomainIdentityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateDomainIdentityResponse {
    return new CreateDomainIdentityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateDomainIdentityResponse {
    return new CreateDomainIdentityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateDomainIdentityResponse {
    return new CreateDomainIdentityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateDomainIdentityResponse | PlainMessage<CreateDomainIdentityResponse> | undefined, b: CreateDomainIdentityResponse | PlainMessage<CreateDomainIdentityResponse> | undefined): boolean {
    return proto3.util.equals(CreateDomainIdentityResponse, a, b);
  }
}

/**
 * @generated from message backend.v1.VerifyIdentityRequest
 */
export class VerifyIdentityRequest extends Message<VerifyIdentityRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<VerifyIdentityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "backend.v1.VerifyIdentityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyIdentityRequest {
    return new VerifyIdentityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyIdentityRequest {
    return new VerifyIdentityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyIdentityRequest {
    return new VerifyIdentityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyIdentityRequest | PlainMessage<VerifyIdentityRequest> | undefined, b: VerifyIdentityRequest | PlainMessage<VerifyIdentityRequest> | undefined): boolean {
    return proto3.util.equals(VerifyIdentityRequest, a, b);
  }
}

